/* ============================================
   IEDNEX - Premium PC Shop
   Main JavaScript
   ============================================ */

(function() {
    'use strict';

    /* ===== Helper Functions ===== */
    const $ = (sel, parent = document) => parent.querySelector(sel);
    const $$ = (sel, parent = document) => [...parent.querySelectorAll(sel)];

    // WooCommerce integration flag.
    // Injected by the WordPress theme via footer.php (window.IEDNEX_WC).
    // When WooCommerce is active the demo cart is disabled and "Add To Order"
    // buttons redirect to the WooCommerce cart page instead.
    const IEDNEX_WC = window.IEDNEX_WC === true;
    const IEDNEX_WC_URL = window.IEDNEX_WC_CART_URL || '#';
    const IEDNEX_WC_ACCOUNT_URL = window.IEDNEX_WC_ACCOUNT_URL || '';

    /* ===== i18n Dictionary ===== */
    const I18N = {
        de: {
            'html.title': 'IEDNEX | Premium Gaming PCs & Workstations',
            'tb.slide1': '🔥 GAMESCOM 2026 Sonderangebote — Messe-Konfigurationen, limitiert!',
            'tb.slide2': '🚚 Kostenloser Versand · 7 Tage Rückgaberecht · 3 Jahre Garantie',
            'tb.slide3': '💰 0% Finanzierung · Bis zu 36 Raten',
            'tb.help': 'Hilfe',
            'tb.track': 'Bestellung verfolgen',
            'tb.region': 'DE',
            'nav.gaming': 'Gaming PCs',
            'nav.brands': 'Marken',
            'nav.config': 'Konfigurator',
            'nav.topsellers': 'Bestseller',
            'nav.customlabs': 'Custom Labs',
            'nav.whyus': 'Warum wir',
            'dd.gamingSystems': 'Gaming-Systeme',
            'dd.ryzen': 'Ryzen 9000 Serie',
            'dd.intel': 'Intel Core Ultra Serie',
            'dd.rtx50': 'RTX 50 Systeme',
            'dd.rx90': 'RX 9000 Systeme',
            'dd.editions': 'Editionen',
            'dd.white': 'White Edition',
            'dd.silent': 'Silent Edition',
            'dd.mini': 'Mini PCs',
            'dd.itx': 'ITX Builds',
            'dd.budget': 'Nach Budget',
            'dd.b1': 'Unter 1.500 €',
            'dd.b2': '1.500 - 2.500 €',
            'dd.b3': '2.500 - 4.000 €',
            'dd.b4': 'Über 4.000 €',
            'search.placeholder': 'Produkte, Konfigurationen, Modelle suchen...',
            'search.btn': 'Suchen',
            'h1.tag': 'GAMESCOM 2026',
            'h1.t1': 'Messe-Konfigurationen',
            'h1.t2': 'Zum Sonderpreis',
            'h1.desc': 'Die besten Messe-Konfigurationen mit Ryzen 9000X3D und RTX 50 Serie – zu nie dagewesenen Preisen.',
            'h1.cta1': 'Jetzt kaufen',
            'h1.cta2': 'Konfigurieren',
            'h2.tag': 'AMD RADEON™ AI PRO',
            'h2.t1': 'Effiziente AI-Workflows',
            'h2.t2': 'R9700 GPU',
            'h2.desc': 'Mit der AMD Radeon™ AI Pro R9700 – starke Leistung für AI-Training, Inferenz und Rendering.',
            'h2.cta1': 'Mehr erfahren',
            'h2.cta2': 'Workstation konfigurieren',
            'h3.tag': 'CUSTOM LABS',
            'h3.t1': 'Deine Idee.',
            'h3.t2': 'Dein System.',
            'h3.desc': 'Nicht mit dem Standard zufrieden? Unser Custom Labs Team baut dein komplett individuelles Wunschsystem.',
            'h3.cta1': 'Jetzt starten',
            'h3.cta2': 'Unsere Qualität',
            'h3.s1': 'Vollständig individuell',
            'h3.s2': 'Custom-Loop-Wasserkühlung',
            'h3.s3': 'Individuelle Beleuchtung',
            'h3.s4': 'Personalisierte Paneele',
            'h3.price': 'Auf Anfrage',
            'cat.title1': 'Finde dein',
            'cat.title2': 'Equipment',
            'cat.subtitle': 'Vom Gaming bis zur Produktivität – für jeden Bedarf',
            'cat.explore': 'Entdecken →',
            'cat.gaming.title': 'Gaming PCs',
            'cat.gaming.desc': 'Riesige Auswahl an konfigurierbaren Gaming-Systemen',
            'cat.editions.title': 'Editionen',
            'cat.editions.desc': 'Gaming-Systeme mit außergewöhnlicher Optik',
            'cat.ws.title': 'Workstations',
            'cat.ws.desc': 'High-End-Workstations für anspruchsvollste Workloads',
            'cat.server.title': 'Server',
            'cat.server.desc': 'Rack-Server von 1U bis 4U, individuell konfiguriert',
            'cat.periph.title': 'Peripherie & Zubehör',
            'cat.periph.desc': 'Ausgewählte Peripherie für dein System',
            'hi.title1': 'Highlights',
            'hi.title2': 'der Marken',
            'hi.subtitle': 'Die besten Produkt-Highlights',
            'hi1.badge': 'AI-WORKFLOWS',
            'hi1.t1': 'Effektive Performance',
            'hi1.t2': 'AMD Radeon™ AI Pro R9700',
            'hi1.link': 'Mehr erfahren →',
            'hi2.badge': 'WORKSTATIONS',
            'hi2.t1': 'Kreiere ohne zu warten',
            'hi2.t2': 'AMD Threadripper™ Pro 9000',
            'hi2.link': 'Mehr erfahren →',
            'hi3.badge': 'POWERED BY',
            'hi3.t1': 'Leistung, die liefert',
            'hi3.t2': 'ASRock Editions',
            'hi3.link': 'Mehr erfahren →',
            'hi4.badge': 'POWERED BY',
            'hi4.t1': 'Made for every match',
            'hi4.t2': 'Logitech G',
            'hi4.link': 'Mehr erfahren →',
            'cfg.title1': 'PC',
            'cfg.title2': 'Konfiguratoren',
            'cfg.subtitle': 'Gestalte dein System komplett selbst!',
            'cfg.tab1': 'Gaming PCs',
            'cfg.tab2': 'High-End PCs',
            'cfg.tab3': 'Mini PCs',
            'cfg.tab4': 'Silent PCs',
            'cfg.tab5': 'Workstations',
            'cfg.tab6': 'Office PCs',
            'cfg.recommended': 'Empfohlen',
            'cfg.flag': 'Flaggschiff',
            'cfg.hot': 'Bestseller',
            'cfg.from': 'ab {{price}} €',
            'cfg.all': 'Alle Konfiguratoren →',
            'cfg.back': 'Zurück',
            'cfg.next': 'Weiter',
            'cfg.addOrder': 'In den Warenkorb',
            'cfg.added': 'Konfiguration zum Warenkorb hinzugefügt',
            'cfg.summary': 'Deine Auswahl',
            'cfg.none': 'Nicht ausgewählt',
            'cfg.total': 'Gesamtpreis',
            'cfg.perf': 'Geschätzte Leistung',
            'cfg.perf.hint': 'Wähle CPU & GPU für die Leistungsprognose.',
            'cfg.perf.note': 'Prognose @ 1440p · FPS-Spiele',
            'cfg.remove': 'Entfernen',
            'cfg.step.cpu': 'Prozessor',
            'cfg.step.cpu.d': 'Die CPU bestimmt Rechenleistung und Multitasking – perfekt für Gaming und Workstations.',
            'cfg.step.gpu': 'Grafikkarte',
            'cfg.step.gpu.d': 'Die Grafikkarte entscheidet über FPS und Auflösung in deinen Spielen.',
            'cfg.step.ram': 'Arbeitsspeicher',
            'cfg.step.ram.d': 'Mehr RAM bedeutet flüssigeres Multitasking und stabilere Arbeitssitzungen.',
            'cfg.step.storage': 'Festplatte',
            'cfg.step.storage.d': 'Wähle schnelle NVMe-SSDs oder große HDDs für deine Daten.',
            'cfg.step.case': 'Gehäuse',
            'cfg.step.case.d': 'Das Gehäuse bestimmt Formfaktor, Optik und Kühlpotential.',
            'cfg.step.cooler': 'Kühlung',
            'cfg.step.cooler.d': 'Luft- oder Wasserkühlung – entscheide nach Lautstärke und Leistung.',
            'cfg.step.need': 'Bitte wähle zuerst eine Option',
            'cfg.step.tip': 'Klicke auf eine Komponente, um fortzufahren',
            'cfg.step.last': 'Letzter Schritt – prüfe deine Auswahl und bestelle',
            'cfg.step.done': 'Auswahl abgeschlossen ✓',
            'cfg.g.title': 'Gaming PC Konfigurator',
            'cfg.g.desc': 'Gaming-PCs bestehen aus den leistungsstärksten Komponenten und sind dein verlässlicher Begleiter im nächsten Match.',
            'cfg.g.f1': 'Über 10.000 Komponenten',
            'cfg.g.f2': 'FPS-Checker',
            'cfg.g.f3': 'Von Gamern für Gamer',
            'cfg.g.f4': '72h Stresstest',
            'cfg.g.s1d': 'Neueste Zen5 Architektur, 3D V-Cache',
            'cfg.g.s1b': 'Konfigurieren',
            'cfg.g.s2d': 'Arrow Lake Architektur, AI-Beschleunigung',
            'cfg.g.s2b': 'Konfigurieren',
            'cfg.h.title': 'High-End PC Konfigurator',
            'cfg.h.desc': 'Kompromisslose Performance – mit den neuesten Flaggschiff-Komponenten.',
            'cfg.h.f1': 'Flaggschiff CPU + GPU',
            'cfg.h.f2': 'Wasserkühlung',
            'cfg.h.f3': 'RGB-Beleuchtung',
            'cfg.h.f4': '4K/8K High-Refresh',
            'cfg.h.s1d': '16 Kerne, Dual 3D V-Cache',
            'cfg.h.s1b': 'Konfigurieren',
            'cfg.h.s2d': '24 Kerne, AI-Leistung',
            'cfg.h.s2b': 'Konfigurieren',
            'cfg.m.title': 'Mini PC Konfigurator',
            'cfg.m.desc': 'Klein aber oho – Desktop-Performance im handlichen Format.',
            'cfg.m.f1': 'ITX kompaktes Design',
            'cfg.m.f2': 'Effizient & leise',
            'cfg.m.f3': 'Leise Kühlung',
            'cfg.m.f4': 'Tragbar & flexibel',
            'cfg.m.s1d': '12 Kerne, Desktop-GPU',
            'cfg.m.s1b': 'Konfigurieren',
            'cfg.m.s2d': 'AI-Beschleunigung, super kompakt',
            'cfg.m.s2b': 'Konfigurieren',
            'cfg.s.title': 'Silent PC Konfigurator',
            'cfg.s.desc': 'Null Geräusch – perfekte Umgebung für Kreative und Fokus.',
            'cfg.s.f1': 'Passivkühlung',
            'cfg.s.f2': 'Silent-Lüfter & Dämpfung',
            'cfg.s.f3': 'Schalldämmendes Gehäuse',
            'cfg.s.f4': 'Unter 20 dB',
            'cfg.s.s1n': 'Silent Ryzen Edition',
            'cfg.s.s1d': 'Lüfterlos, 65W TDP',
            'cfg.s.s1b': 'Konfigurieren',
            'cfg.w.title': 'Workstation Konfigurator',
            'cfg.w.desc': 'Professionelle Workstations für die anspruchsvollsten Workloads.',
            'cfg.w.f1': 'Threadripper Pro Support',
            'cfg.w.f2': 'ECC-Speicher',
            'cfg.w.f3': 'Profi-GPUs (RTX Pro / Radeon Pro)',
            'cfg.w.f4': 'RAID-Speicherlösungen',
            'cfg.w.s1d': 'Bis zu 96 Kerne / 192 Threads',
            'cfg.w.s1b': 'Konfigurieren',
            'cfg.w.s2d': 'Intel Top-Workstation-Plattform',
            'cfg.w.s2b': 'Konfigurieren',
            'cfg.o.title': 'Office PC Konfigurator',
            'cfg.o.desc': 'Effiziente Büro-PCs – stabil, zuverlässig und preiswert.',
            'cfg.o.f1': 'Effizient & sparsam',
            'cfg.o.f2': 'Kompaktes Design',
            'cfg.o.f3': 'Unternehmensstabilität',
            'cfg.o.f4': '3 Jahre Vor-Ort-Service',
            'cfg.o.s1n': 'Ryzen 5 9600 Office',
            'cfg.o.s1d': '6 Kerne, niedriger Verbrauch',
            'cfg.o.s1b': 'Konfigurieren',
            'cfg.o.s2n': 'Core Ultra 5 Office',
            'cfg.o.s2d': 'AI-beschleunigtes Arbeiten',
            'cfg.o.s2b': 'Konfigurieren',
            'spec.cpu': 'CPU',
            'spec.board': 'Mainboard',
            'spec.gpu': 'GPU',
            'spec.ram': 'RAM',
            'spec.storage': 'Storage',
            'spec.noise': 'Geräusch',
            'spec.screen': 'Display',
            'spec.igpu': 'Integriert',
            'labs.badge': 'IEDNEX CUSTOM LABS',
            'labs.t1': 'Deine Idee.',
            'labs.t2': 'Dein System.',
            'labs.desc': 'Nicht mit dem Standard zufrieden? Wir auch nicht! Wir bauen dein Traumsystem – ganz auf dich zugeschnitten und individualisiert.',
            'labs.cta': 'Mehr erfahren →',
            'adv.title1': 'Warum',
            'adv.title2': 'IEDNEX?',
            'adv.subtitle': 'Deine Vorteile',
            'adv1.t': '72h Stresstest',
            'adv1.d': 'Jedes System wird vor Auslieferung 72 Stunden unter Volllast getestet – 100% Stabilität garantiert.',
            'adv2.t': '3 Jahre Garantie',
            'adv2.d': 'Alle Systeme mit 3 Jahren Herstellergarantie, optional erweiterbar auf 5 Jahre.',
            'adv3.t': 'Kostenloser Versand',
            'adv3.d': 'Kostenloser Versand in ganz Deutschland, Lieferzeit 3-5 Werktage.',
            'adv4.t': '0% Finanzierung',
            'adv4.d': '0% Zinsen in 3-36 Raten – mit Partnerbanken.',
            'adv5.t': 'Individuelle Anpassung',
            'adv5.d': 'Vom RGB bis zum Kabelmanagement – jedes Detail nach deinem Geschmack.',
            'adv6.t': 'Lebenslanger Support',
            'adv6.d': 'Technisches Team 7×24 erreichbar – wir stehen dir nach dem Kauf zur Seite.',
            'ts.title1': 'Die besten',
            'ts.title2': 'Deals',
            'ts.subtitle': 'Die besten Deals für deine Ansprüche',
            'ts.tab1': 'Desktop-PCs',
            'ts.tab2': 'Laptops',
            'ts.tab3': 'Workstations',
            'ts.new': 'NEU',
            'ts.configure': 'Jetzt konfigurieren',
            'ts.buy': 'Jetzt kaufen',
            'ts.stock': 'Lieferzeit: 5-7 Werktage',
            'ts.stock2': 'Auf Lager · Versand am nächsten Tag',
            'ts.stock3': 'Lieferzeit: 7-10 Werktage',
            'ts.all': 'Alle Deals & Specials →',
            'ts.finance': 'ab {{price}} €/Monat · 0% Finanzierung',
            'consult.badge': 'IEDNEX BERATUNG',
            'consult.title': 'Etwas ratlos?',
            'consult.desc': 'Lass dich unverbindlich und genau auf deine Bedürfnisse abgestimmt beraten – finde dein nächstes Traum-Setup!',
            'consult.cta': 'Zur Beratung →',
            'news.title': 'IEDNEX Newsletter',
            'news.desc': 'Neuigkeiten, exklusive Deals und individuelle Konfigurationen – zuerst für dich.',
            'news.placeholder': 'Deine E-Mail-Adresse',
            'news.btn': 'Abonnieren',
            'news.note': 'Mit dem Abonnieren stimmst du unserer Datenschutzerklärung zu. Jederzeit abbestellbar.',
            'foot.tagline': 'Premium Gaming PCs & Workstations – made in Germany.',
            'foot.prod': 'Produkte',
            'foot.p1': 'Gaming PCs',
            'foot.p2': 'High-End PCs',
            'foot.p3': 'Workstations',
            'foot.p4': 'Laptops',
            'foot.p5': 'Mini PCs',
            'foot.p6': 'Peripherie',
            'foot.serv': 'Service',
            'foot.s1': 'Online-Konfigurator',
            'foot.s2': 'Custom Labs',
            'foot.s3': 'Beratung',
            'foot.s4': 'Trade-In',
            'foot.s5': 'Business-Lösungen',
            'foot.sup': 'Support',
            'foot.u1': 'Hilfe-Center',
            'foot.u2': 'Bestellung verfolgen',
            'foot.u3': 'Garantie',
            'foot.u4': 'Rückgabe',
            'foot.u5': 'Treiber',
            'foot.about': 'Über uns',
            'foot.a1': 'Über IEDNEX',
            'foot.a2': 'News',
            'foot.a3': 'Karriere',
            'foot.a4': 'Partner',
            'foot.a5': 'Kontakt',
            'foot.pay': 'Zahlungsarten:',
            'foot.privacy': 'Datenschutz',
            'foot.terms': 'AGB',
            'foot.cookies': 'Cookie-Einstellungen',
            'foot.impressum': 'Impressum · Made in Germany',
            'foot.imprint': 'Impressum',
            'foot.madein': 'Made in Germany',
            'cart.title': 'Warenkorb',
            'cart.empty1': 'Dein Warenkorb ist leer',
            'cart.empty2': 'Füge dein Wunschsystem hinzu',
            'cart.total': 'Gesamt',
            'cart.checkout': 'Zur Kasse',
            'cart.itemDesc': 'Individuell konfiguriert · 5-7 Werktage',
            'toast.added': '„{{name}}" zum Warenkorb hinzugefügt',
            'toast.addedOk': 'Hinzugefügt ✓',
            /* --- Account / Auth --- */
            'auth.login.title': 'Anmelden',
            'auth.login.sub': 'Willkommen zurück bei IEDNEX',
            'auth.login.submit': 'Anmelden',
            'auth.login.noAccount': 'Noch kein Konto?',
            'auth.login.register': 'Jetzt registrieren',
            'auth.register.title': 'Persönliche Informationen',
            'auth.register.sub': 'Konfigurationen speichern, Bestellungen verfolgen & mehr',
            'auth.register.submit': 'Kundenkonto erstellen',
            'auth.register.hasAccount': 'Schon ein Konto?',
            'auth.register.login': 'Zum Login',
            'auth.firstName': 'Vorname',
            'auth.lastName': 'Nachname',
            'auth.email': 'E-Mail',
            'auth.name': 'Vor- und Nachname',
            'auth.password': 'Passwort',
            'auth.password.hint': 'Mindestens 8 Zeichen',
            'auth.confirm': 'Passwort bestätigen',
            'auth.terms': 'Ich akzeptiere die AGB und die Datenschutzerklärung von IEDNEX.',
            'auth.business': 'Ich bin Geschäftskunde',
            'auth.newsletter': 'Ja, ich möchte den Newsletter abonnieren und Infos über Angebote, Aktionen & Gewinnspiele erhalten.',
            'auth.benefits.title': 'Vorteile Deines Kundenkontos',
            'auth.benefits.b1': 'Produktion Deines PCs mitverfolgen',
            'auth.benefits.b2': 'Updates zu Bestellung & Lieferung',
            'auth.benefits.b3': 'Sendungsverfolgung mit LiveTracking',
            'auth.strength.weak': 'Schwach',
            'auth.strength.medium': 'Mittel',
            'auth.strength.strong': 'Stark',
            'auth.err.name': 'Bitte gib deinen Namen ein (mindestens 2 Zeichen).',
            'auth.err.firstName': 'Bitte gib deinen Vornamen ein.',
            'auth.err.lastName': 'Bitte gib deinen Nachnamen ein.',
            'auth.err.email': 'Bitte gib eine gültige E-Mail-Adresse ein.',
            'auth.err.exists': 'Für diese E-Mail-Adresse existiert bereits ein Konto.',
            'auth.err.len': 'Das Passwort muss mindestens 8 Zeichen lang sein.',
            'auth.err.match': 'Die Passwörter stimmen nicht überein.',
            'auth.err.terms': 'Bitte akzeptiere AGB und Datenschutzerklärung.',
            'auth.err.invalid': 'E-Mail oder Passwort ist falsch.',
            'auth.err.current': 'Das aktuelle Passwort ist falsch.',
            'auth.profile.info': 'Kontodaten',
            'auth.save': 'Speichern',
            'auth.saved': 'Gespeichert ✓',
            'auth.lang': 'Sprache',
            'auth.memberSince': 'Mitglied seit {{date}}',
            'auth.pw.title': 'Passwort ändern',
            'auth.pw.current': 'Aktuelles Passwort',
            'auth.pw.new': 'Neues Passwort',
            'auth.pw.submit': 'Passwort aktualisieren',
            'auth.pw.ok': 'Passwort aktualisiert ✓',
            'auth.orders.title': 'Bestellungen',
            'auth.orders.empty': 'Noch keine Bestellungen.',
            'auth.orders.items': '{{n}} Artikel',
            'auth.orders.status': 'In Bearbeitung',
            'auth.orders.id': 'Bestellung',
            'auth.logout': 'Abmelden',
            'auth.delete': 'Konto löschen',
            'auth.deleteConfirm': 'Möchtest du dein Konto wirklich unwiderruflich löschen?',
            'auth.welcome': 'Willkommen, {{name}}! 👋',
            'auth.bye': 'Du wurdest abgemeldet.',
            'auth.deleted': 'Dein Konto wurde gelöscht.',
            'auth.checkout.login': 'Bitte melde dich an, um die Bestellung abzuschließen.',
            'auth.checkout.ok': 'Vielen Dank! Deine Bestellung {{id}} ist eingegangen.',
            'auth.note': 'Demo-Konto: Deine Daten werden ausschließlich lokal in deinem Browser gespeichert.',
            'news.success': 'Abonniert! Deals an {{email}} gesendet',
            'comp.title1': 'Hardware',
            'comp.title2': 'Komponenten',
            'comp.subtitle': 'Kuratierte Komponenten für dein System – jederzeit verfügbar.',
            'comp.note': '* Alle Komponenten sind mit allen IEDNEX-Systemen kompatibel und werden vor Versand geprüft. Auf Anfrage auch einzeln bestellbar.',
            'comp.compare': 'Vergleichen',
            'comp.compareTitle': 'Komponentenvergleich',
            'comp.stock.in': 'Auf Lager',
            'comp.stock.low': 'Begrenzte Stückzahl',
            'comp.stock.act': 'Aktive',
            'comp.add': 'Zum Auftrag',
            'comp.added': 'Zum Auftrag hinzugefügt ✓',
            'comp.compared': 'Zum Vergleich hinzugefügt',
            'comp.maxCompare': 'Maximal 4 Komponenten vergleichbar',
            'comp.clear': 'Alle löschen',
            'comp.cat.cpu': 'CPU Prozessoren',
            'comp.cat.gpu': 'GPU Grafikkarten',
            'comp.cat.ram': 'RAM Arbeitsspeicher',
            'comp.cat.ssd': 'SSD Solid State Drives',
            'comp.cat.hdd': 'HDD Festplatten',
            'comp.cat.case': 'Case Gehäuse',
            'comp.cat.psu': 'PSU Netzteile',
            'comp.cat.monitor': 'Monitor Displays',
            'comp.cat.ups': 'USV Stromschutz',
            'comp.cat.cooler': 'Cooler Kühlung',
            'comp.spec.brand': 'Marke',
            'comp.spec.model': 'Modell',
            'comp.spec.part': 'Artikelnr.',
            'comp.spec.price': 'Preis',
            'comp.spec.stock': 'Verfügbarkeit',
            'comp.spec.socket': 'Sockel',
            'comp.spec.cores': 'Kerne',
            'comp.spec.boost': 'Boost-Takt',
            'comp.spec.cache': 'Cache',
            'comp.spec.memory': 'Speicher',
            'comp.spec.bandwidth': 'Bandbreite',
            'comp.spec.interface': 'Schnittstelle',
            'comp.spec.capacity': 'Kapazität',
            'comp.spec.speed': 'Geschwindigkeit',
            'comp.spec.watt': 'Leistung',
            'comp.spec.type': 'Art',
            'comp.spec.tdp': 'TDP',
            'comp.spec.size': 'Größe',
            'comp.spec.panel': 'Panel',
            'comp.spec.resolution': 'Auflösung',
            'comp.spec.refresh': 'Bildwiederhol',
            'comp.spec.rpm': 'Drehzahl',
            'comp.spec.form': 'Formfaktor',
            'comp.spec.family': 'Serie',
            'deals.title1': 'Deals &',
            'deals.title2': 'Specials',
            'deals.subtitle': 'Aktionen, Messe-Deals und geprüfte Retouren – nur solange der Vorrat reicht.',
            'deals.tab.messe': 'Messe Deals',
            'deals.tab.kickass': 'Kick-Ass Systeme',
            'deals.tab.refurb': 'Refurbished & Retested',
            'deals.limited': 'Nur begrenzt verfügbar',
            'deals.refurbBadge': 'Geprüft & zertifiziert',
            'deals.saving': 'Du sparst',
            'deals.add': 'In den Warenkorb',
            'deals.added': 'Hinzugefügt ✓',
            'fps.title1': 'FPS-',
            'fps.title2': 'Checker',
            'fps.subtitle': 'Finde die passende Leistung für deine Spiele – Schätzung in Sekunden.',
            'fps.cpu': 'CPU',
            'fps.gpu': 'GPU',
            'fps.res': 'Auflösung',
            'fps.game': 'Spieltyp',
            'fps.cpu.1': 'AMD Ryzen 5 7500F',
            'fps.cpu.2': 'AMD Ryzen 7 9800X3D',
            'fps.cpu.3': 'AMD Ryzen 9 9950X3D',
            'fps.gpu.1': 'RTX 5060 / RX 9060 XT',
            'fps.gpu.2': 'RTX 5070 Ti / RX 9070 XT',
            'fps.gpu.3': 'RTX 5090 / RX 9090 XT',
            'fps.res.1': '1080p (Full HD)',
            'fps.res.2': '1440p (WQHD)',
            'fps.res.3': '4K (UHD)',
            'fps.game.fps': 'Ego-Shooter (CS2, Valorant)',
            'fps.game.rts': 'Strategie (RTS)',
            'fps.game.aa': 'AAA-Blockbuster',
            'fps.result': 'Geschätzte Leistung',
            'fps.empty': 'Wähle deine Komponenten und berechne die Leistung.',
            'fps.fps': 'FPS',
            'fps.rating.elite': 'ELITE – für Profis',
            'fps.rating.high': 'Sehr flüssig',
            'fps.rating.mid': 'Spielbar',
            'fps.rating.low': 'Nicht empfohlen',
            'fps.suggest': 'Empfohlene Konfiguration',
            'fps.tier.1': 'Einstieg',
            'fps.tier.2': 'High-End',
            'fps.tier.3': 'Enthusiast',
            'fps.cta': 'Jetzt konfigurieren',
        },
        en: {
            'html.title': 'IEDNEX | Premium Gaming PCs & Workstations',
            'tb.slide1': '🔥 GAMESCOM 2026 Deals — trade show configs, limited time!',
            'tb.slide2': '🚚 Free shipping · 7-day returns · 3-year warranty',
            'tb.slide3': '💰 0% financing · up to 36 installments',
            'tb.help': 'Help',
            'tb.track': 'Track order',
            'tb.region': 'EN',
            'nav.gaming': 'Gaming PCs',
            'nav.brands': 'Brands',
            'nav.config': 'Configurator',
            'nav.topsellers': 'Top Sellers',
            'nav.customlabs': 'Custom Labs',
            'nav.whyus': 'Why Us',
            'dd.gamingSystems': 'Gaming Systems',
            'dd.ryzen': 'Ryzen 9000 Series',
            'dd.intel': 'Intel Core Ultra Series',
            'dd.rtx50': 'RTX 50 Systems',
            'dd.rx90': 'RX 9000 Systems',
            'dd.editions': 'Editions',
            'dd.white': 'White Edition',
            'dd.silent': 'Silent Edition',
            'dd.mini': 'Mini PCs',
            'dd.itx': 'ITX Builds',
            'dd.budget': 'By Budget',
            'dd.b1': 'Under €1,500',
            'dd.b2': '€1,500 - €2,500',
            'dd.b3': '€2,500 - €4,000',
            'dd.b4': 'Over €4,000',
            'search.placeholder': 'Search products, configs, models...',
            'search.btn': 'Search',
            'h1.tag': 'GAMESCOM 2026',
            'h1.t1': 'Show Floor Configs',
            'h1.t2': 'At Unbeatable Prices',
            'h1.desc': 'The best trade show configs with Ryzen 9000X3D and RTX 50 series – at unprecedented prices.',
            'h1.cta1': 'Shop Now',
            'h1.cta2': 'Customize',
            'h2.tag': 'AMD RADEON™ AI PRO',
            'h2.t1': 'Efficient AI Workflows',
            'h2.t2': 'R9700 GPU',
            'h2.desc': 'Powered by AMD Radeon™ AI Pro R9700 – powerful performance for AI training, inference and rendering.',
            'h2.cta1': 'Learn More',
            'h2.cta2': 'Configure Workstation',
            'h3.tag': 'CUSTOM LABS',
            'h3.t1': 'Your Idea.',
            'h3.t2': 'Your System.',
            'h3.desc': 'Not satisfied with standard? Our Custom Labs team builds your completely individual dream system.',
            'h3.cta1': 'Get Started',
            'h3.cta2': 'Our Quality',
            'h3.s1': 'Fully custom',
            'h3.s2': 'Custom-loop water cooling',
            'h3.s3': 'Custom lighting',
            'h3.s4': 'Personalized panels',
            'h3.price': 'On request',
            'cat.title1': 'Find Your',
            'cat.title2': 'Gear',
            'cat.subtitle': 'From gaming to productivity – for every need',
            'cat.explore': 'Explore →',
            'cat.gaming.title': 'Gaming PCs',
            'cat.gaming.desc': 'Huge selection of configurable gaming systems',
            'cat.editions.title': 'Editions',
            'cat.editions.desc': 'Gaming systems with extraordinary looks',
            'cat.ws.title': 'Workstations',
            'cat.ws.desc': 'High-end workstations for demanding workloads',
            'cat.server.title': 'Servers',
            'cat.server.desc': 'Rack servers from 1U to 4U, individually configured',
            'cat.periph.title': 'Peripherals & Accessories',
            'cat.periph.desc': 'Curated peripherals to complete your system',
            'hi.title1': 'Highlights',
            'hi.title2': 'of Brands',
            'hi.subtitle': 'The best product highlights',
            'hi1.badge': 'AI WORKFLOWS',
            'hi1.t1': 'Effective Performance',
            'hi1.t2': 'AMD Radeon™ AI Pro R9700',
            'hi1.link': 'Learn more →',
            'hi2.badge': 'WORKSTATIONS',
            'hi2.t1': 'Create Without Waiting',
            'hi2.t2': 'AMD Threadripper™ Pro 9000',
            'hi2.link': 'Learn more →',
            'hi3.badge': 'POWERED BY',
            'hi3.t1': 'Performance That Delivers',
            'hi3.t2': 'ASRock Editions',
            'hi3.link': 'Learn more →',
            'hi4.badge': 'POWERED BY',
            'hi4.t1': 'Made for every match',
            'hi4.t2': 'Logitech G',
            'hi4.link': 'Learn more →',
            'cfg.title1': 'PC',
            'cfg.title2': 'Configurators',
            'cfg.subtitle': 'Build your system completely yourself!',
            'cfg.tab1': 'Gaming PCs',
            'cfg.tab2': 'High-End PCs',
            'cfg.tab3': 'Mini PCs',
            'cfg.tab4': 'Silent PCs',
            'cfg.tab5': 'Workstations',
            'cfg.tab6': 'Office PCs',
            'cfg.recommended': 'Recommended',
            'cfg.flag': 'Flagship',
            'cfg.hot': 'Bestseller',
            'cfg.from': 'from €{{price}}',
            'cfg.all': 'All Configurators →',
            'cfg.back': 'Back',
            'cfg.next': 'Next',
            'cfg.addOrder': 'Add to Order',
            'cfg.added': 'Configuration added to your order',
            'cfg.summary': 'Your Selection',
            'cfg.none': 'Not selected',
            'cfg.total': 'Total Price',
            'cfg.perf': 'Estimated Performance',
            'cfg.perf.hint': 'Select CPU & GPU for the performance estimate.',
            'cfg.perf.note': 'Estimate @ 1440p · FPS games',
            'cfg.remove': 'Remove',
            'cfg.step.cpu': 'Processor',
            'cfg.step.cpu.d': 'The CPU drives compute and multitasking – ideal for gaming and workstations.',
            'cfg.step.gpu': 'Graphics Card',
            'cfg.step.gpu.d': 'The GPU decides your FPS and resolution in games.',
            'cfg.step.ram': 'Memory',
            'cfg.step.ram.d': 'More RAM means smoother multitasking and more stable sessions.',
            'cfg.step.storage': 'Storage',
            'cfg.step.storage.d': 'Pick fast NVMe SSDs or large HDDs for your data.',
            'cfg.step.case': 'Case',
            'cfg.step.case.d': 'The case defines form factor, looks and cooling headroom.',
            'cfg.step.cooler': 'Cooling',
            'cfg.step.cooler.d': 'Air or liquid – choose by noise and performance.',
            'cfg.step.need': 'Please select an option first',
            'cfg.step.tip': 'Click a component to continue',
            'cfg.step.last': 'Last step – review your selection and order',
            'cfg.step.done': 'Selection complete ✓',
            'cfg.g.title': 'Gaming PC Configurator',
            'cfg.g.desc': 'Gaming PCs consist of the most powerful components and are your reliable companion in the next match.',
            'cfg.g.f1': 'Over 10,000 components',
            'cfg.g.f2': 'FPS checker',
            'cfg.g.f3': 'By gamers for gamers',
            'cfg.g.f4': '72h stress test',
            'cfg.g.s1d': 'Latest Zen5 architecture, 3D V-Cache',
            'cfg.g.s1b': 'Configure',
            'cfg.g.s2d': 'Arrow Lake architecture, AI acceleration',
            'cfg.g.s2b': 'Configure',
            'cfg.h.title': 'High-End PC Configurator',
            'cfg.h.desc': 'Uncompromising performance – with the latest flagship components.',
            'cfg.h.f1': 'Flagship CPU + GPU',
            'cfg.h.f2': 'Water cooling',
            'cfg.h.f3': 'RGB lighting',
            'cfg.h.f4': '4K/8K high refresh',
            'cfg.h.s1d': '16 cores, dual 3D V-Cache',
            'cfg.h.s1b': 'Configure',
            'cfg.h.s2d': '24 cores, AI performance',
            'cfg.h.s2b': 'Configure',
            'cfg.m.title': 'Mini PC Configurator',
            'cfg.m.desc': 'Small but mighty – desktop performance in a compact form factor.',
            'cfg.m.f1': 'ITX compact design',
            'cfg.m.f2': 'Efficient & quiet',
            'cfg.m.f3': 'Silent cooling',
            'cfg.m.f4': 'Portable & flexible',
            'cfg.m.s1d': '12 cores, desktop GPU',
            'cfg.m.s1b': 'Configure',
            'cfg.m.s2d': 'AI acceleration, ultra compact',
            'cfg.m.s2b': 'Configure',
            'cfg.s.title': 'Silent PC Configurator',
            'cfg.s.desc': 'Zero noise – the perfect environment for creatives and focus.',
            'cfg.s.f1': 'Passive cooling',
            'cfg.s.f2': 'Silent fans & damping',
            'cfg.s.f3': 'Sound-dampening case',
            'cfg.s.f4': 'Under 20 dB',
            'cfg.s.s1n': 'Silent Ryzen Edition',
            'cfg.s.s1d': 'Fanless, 65W TDP',
            'cfg.s.s1b': 'Configure',
            'cfg.w.title': 'Workstation Configurator',
            'cfg.w.desc': 'Professional workstations for the most demanding workloads.',
            'cfg.w.f1': 'Threadripper Pro support',
            'cfg.w.f2': 'ECC memory',
            'cfg.w.f3': 'Pro GPUs (RTX Pro / Radeon Pro)',
            'cfg.w.f4': 'RAID storage solutions',
            'cfg.w.s1d': 'Up to 96 cores / 192 threads',
            'cfg.w.s1b': 'Configure',
            'cfg.w.s2d': 'Intel top workstation platform',
            'cfg.w.s2b': 'Configure',
            'cfg.o.title': 'Office PC Configurator',
            'cfg.o.desc': 'Efficient office PCs – stable, reliable and affordable.',
            'cfg.o.f1': 'Efficient & economical',
            'cfg.o.f2': 'Compact design',
            'cfg.o.f3': 'Enterprise stability',
            'cfg.o.f4': '3-year on-site service',
            'cfg.o.s1n': 'Ryzen 5 9600 Office',
            'cfg.o.s1d': '6 cores, low power',
            'cfg.o.s1b': 'Configure',
            'cfg.o.s2n': 'Core Ultra 5 Office',
            'cfg.o.s2d': 'AI-accelerated work',
            'cfg.o.s2b': 'Configure',
            'spec.cpu': 'CPU',
            'spec.board': 'Motherboard',
            'spec.gpu': 'GPU',
            'spec.ram': 'RAM',
            'spec.storage': 'Storage',
            'spec.noise': 'Noise',
            'spec.screen': 'Display',
            'spec.igpu': 'Integrated',
            'labs.badge': 'IEDNEX CUSTOM LABS',
            'labs.t1': 'Your Idea.',
            'labs.t2': 'Your System.',
            'labs.desc': 'Not satisfied with the standard? Neither are we! We build your dream system – fully customized and personalized.',
            'labs.cta': 'Learn More →',
            'adv.title1': 'Why',
            'adv.title2': 'IEDNEX?',
            'adv.subtitle': 'Your advantages',
            'adv1.t': '72h Stress Test',
            'adv1.d': 'Every system undergoes a 72-hour full-load stress test before delivery – 100% stability guaranteed.',
            'adv2.t': '3-Year Warranty',
            'adv2.d': 'All systems come with a 3-year manufacturer warranty, optionally extendable to 5 years.',
            'adv3.t': 'Free Shipping',
            'adv3.d': 'Free shipping across Germany, delivery in 3-5 business days.',
            'adv4.t': '0% Financing',
            'adv4.d': '0% interest in 3-36 installments – with partner banks.',
            'adv5.t': 'Custom Tailoring',
            'adv5.d': 'From RGB to cable management – every detail to your taste.',
            'adv6.t': 'Lifetime Support',
            'adv6.d': 'Technical team available 7×24 – we stand by you after purchase.',
            'ts.title1': 'The Best',
            'ts.title2': 'Deals',
            'ts.subtitle': 'The best deals for your needs',
            'ts.tab1': 'Desktop PCs',
            'ts.tab2': 'Laptops',
            'ts.tab3': 'Workstations',
            'ts.new': 'NEW',
            'ts.configure': 'Configure Now',
            'ts.buy': 'Buy Now',
            'ts.stock': 'Delivery: 5-7 business days',
            'ts.stock2': 'In stock · Ships next day',
            'ts.stock3': 'Delivery: 7-10 business days',
            'ts.all': 'All Deals & Specials →',
            'ts.finance': 'from €{{price}}/mo · 0% APR',
            'consult.badge': 'IEDNEX CONSULTING',
            'consult.title': 'Feeling lost?',
            'consult.desc': 'Get free, personalized advice tailored to your needs – find your next dream setup!',
            'consult.cta': 'Book a consult →',
            'news.title': 'IEDNEX Newsletter',
            'news.desc': 'News, exclusive deals and custom configurations – first for you.',
            'news.placeholder': 'Your email address',
            'news.btn': 'Subscribe',
            'news.note': 'By subscribing you agree to our privacy policy. Unsubscribe anytime.',
            'foot.tagline': 'Premium Gaming PCs & Workstations – engineered in Germany.',
            'foot.prod': 'Products',
            'foot.p1': 'Gaming PCs',
            'foot.p2': 'High-End PCs',
            'foot.p3': 'Workstations',
            'foot.p4': 'Laptops',
            'foot.p5': 'Mini PCs',
            'foot.p6': 'Peripherals',
            'foot.serv': 'Services',
            'foot.s1': 'Online Configurator',
            'foot.s2': 'Custom Labs',
            'foot.s3': 'Consulting',
            'foot.s4': 'Trade-In',
            'foot.s5': 'Business Solutions',
            'foot.sup': 'Support',
            'foot.u1': 'Help Center',
            'foot.u2': 'Track Order',
            'foot.u3': 'Warranty',
            'foot.u4': 'Returns',
            'foot.u5': 'Drivers',
            'foot.about': 'About',
            'foot.a1': 'About IEDNEX',
            'foot.a2': 'News',
            'foot.a3': 'Careers',
            'foot.a4': 'Partners',
            'foot.a5': 'Contact',
            'foot.pay': 'Payment methods:',
            'foot.privacy': 'Privacy Policy',
            'foot.terms': 'Terms & Conditions',
            'foot.cookies': 'Cookie Settings',
            'foot.impressum': 'Imprint · Made in Germany',
            'foot.imprint': 'Imprint',
            'foot.madein': 'Made in Germany',
            'cart.title': 'Shopping Cart',
            'cart.empty1': 'Your cart is empty',
            'cart.empty2': 'Add your dream system to get started',
            'cart.total': 'Total',
            'cart.checkout': 'Checkout',
            'cart.itemDesc': 'Custom configured · 5-7 business days',
            'toast.added': 'Added "{{name}}" to cart',
            'toast.addedOk': 'Added ✓',
            /* --- Account / Auth --- */
            'auth.login.title': 'Sign In',
            'auth.login.sub': 'Welcome back to IEDNEX',
            'auth.login.submit': 'Sign In',
            'auth.login.noAccount': "Don't have an account yet?",
            'auth.login.register': 'Register now',
            'auth.register.title': 'Personal Information',
            'auth.register.sub': 'Save configurations, track orders & more',
            'auth.register.submit': 'Create Customer Account',
            'auth.register.hasAccount': 'Already have an account?',
            'auth.register.login': 'Go to login',
            'auth.firstName': 'First name',
            'auth.lastName': 'Last name',
            'auth.email': 'E-Mail',
            'auth.name': 'First and last name',
            'auth.password': 'Password',
            'auth.password.hint': 'At least 8 characters',
            'auth.confirm': 'Confirm password',
            'auth.terms': 'I accept the IEDNEX Terms & Conditions and Privacy Policy.',
            'auth.business': 'I am a business customer',
            'auth.newsletter': 'Yes, I would like to subscribe to the newsletter and receive information about offers, promotions & competitions.',
            'auth.benefits.title': 'Benefits of your customer account',
            'auth.benefits.b1': 'Track the production of your PC',
            'auth.benefits.b2': 'Updates on order & delivery',
            'auth.benefits.b3': 'Shipment tracking with LiveTracking',
            'auth.strength.weak': 'Weak',
            'auth.strength.medium': 'Medium',
            'auth.strength.strong': 'Strong',
            'auth.err.name': 'Please enter your name (at least 2 characters).',
            'auth.err.firstName': 'Please enter your first name.',
            'auth.err.lastName': 'Please enter your last name.',
            'auth.err.email': 'Please enter a valid email address.',
            'auth.err.exists': 'An account with this email address already exists.',
            'auth.err.len': 'The password must be at least 8 characters long.',
            'auth.err.match': 'The passwords do not match.',
            'auth.err.terms': 'Please accept the Terms & Conditions and Privacy Policy.',
            'auth.err.invalid': 'Email or password is incorrect.',
            'auth.err.current': 'The current password is incorrect.',
            'auth.profile.info': 'Account Details',
            'auth.save': 'Save',
            'auth.saved': 'Saved ✓',
            'auth.lang': 'Language',
            'auth.memberSince': 'Member since {{date}}',
            'auth.pw.title': 'Change Password',
            'auth.pw.current': 'Current password',
            'auth.pw.new': 'New password',
            'auth.pw.submit': 'Update password',
            'auth.pw.ok': 'Password updated ✓',
            'auth.orders.title': 'Orders',
            'auth.orders.empty': 'No orders yet.',
            'auth.orders.items': '{{n}} items',
            'auth.orders.status': 'Processing',
            'auth.orders.id': 'Order',
            'auth.logout': 'Sign Out',
            'auth.delete': 'Delete account',
            'auth.deleteConfirm': 'Do you really want to permanently delete your account?',
            'auth.welcome': 'Welcome, {{name}}! 👋',
            'auth.bye': 'You have been signed out.',
            'auth.deleted': 'Your account has been deleted.',
            'auth.checkout.login': 'Please sign in to complete your order.',
            'auth.checkout.ok': 'Thank you! Your order {{id}} has been received.',
            'auth.note': 'Demo account: your data is stored locally in your browser only.',
            'news.success': 'Subscribed! Deals sent to {{email}}',
            'comp.title1': 'Hardware',
            'comp.title2': 'Components',
            'comp.subtitle': 'Curated components for your system – always available.',
            'comp.note': '* All components are compatible with every IEDNEX system and tested before shipping. Available individually on request.',
            'comp.compare': 'Compare',
            'comp.compareTitle': 'Component Comparison',
            'comp.stock.in': 'In Stock',
            'comp.stock.low': 'Limited Quantity',
            'comp.stock.act': 'Active',
            'comp.add': 'Add To Order',
            'comp.added': 'Added to order ✓',
            'comp.compared': 'Added to compare',
            'comp.maxCompare': 'Maximum 4 components to compare',
            'comp.clear': 'Clear all',
            'comp.cat.cpu': 'CPU Processors',
            'comp.cat.gpu': 'GPU Video Cards',
            'comp.cat.ram': 'RAM Memory',
            'comp.cat.ssd': 'SSD Solid State Drives',
            'comp.cat.hdd': 'HDD Hard Drives',
            'comp.cat.case': 'Case Chassis',
            'comp.cat.psu': 'PSU Power Supplies',
            'comp.cat.monitor': 'Monitor Displays',
            'comp.cat.ups': 'UPS Power Protection',
            'comp.cat.cooler': 'Cooler Cooling',
            'comp.spec.brand': 'Brand',
            'comp.spec.model': 'Model',
            'comp.spec.part': 'Part #',
            'comp.spec.price': 'Price',
            'comp.spec.stock': 'Availability',
            'comp.spec.socket': 'Socket',
            'comp.spec.cores': 'Cores',
            'comp.spec.boost': 'Boost Clock',
            'comp.spec.cache': 'Cache',
            'comp.spec.memory': 'Memory',
            'comp.spec.bandwidth': 'Bandwidth',
            'comp.spec.interface': 'Interface',
            'comp.spec.capacity': 'Capacity',
            'comp.spec.speed': 'Speed',
            'comp.spec.watt': 'Wattage',
            'comp.spec.type': 'Type',
            'comp.spec.tdp': 'TDP',
            'comp.spec.size': 'Size',
            'comp.spec.panel': 'Panel',
            'comp.spec.resolution': 'Resolution',
            'comp.spec.refresh': 'Refresh Rate',
            'comp.spec.rpm': 'RPM',
            'comp.spec.form': 'Form Factor',
            'comp.spec.family': 'Family',
            'deals.title1': 'Deals &',
            'deals.title2': 'Specials',
            'deals.subtitle': 'Promotions, show deals and certified returns – while stock lasts.',
            'deals.tab.messe': 'Show Deals',
            'deals.tab.kickass': 'Kick-Ass Systems',
            'deals.tab.refurb': 'Refurbished & Retested',
            'deals.limited': 'Limited availability',
            'deals.refurbBadge': 'Tested & certified',
            'deals.saving': 'You save',
            'deals.add': 'Add to cart',
            'deals.added': 'Added ✓',
            'fps.title1': 'FPS',
            'fps.title2': 'Checker',
            'fps.subtitle': 'Find the right performance for your games – estimate in seconds.',
            'fps.cpu': 'CPU',
            'fps.gpu': 'GPU',
            'fps.res': 'Resolution',
            'fps.game': 'Game Type',
            'fps.cpu.1': 'AMD Ryzen 5 7500F',
            'fps.cpu.2': 'AMD Ryzen 7 9800X3D',
            'fps.cpu.3': 'AMD Ryzen 9 9950X3D',
            'fps.gpu.1': 'RTX 5060 / RX 9060 XT',
            'fps.gpu.2': 'RTX 5070 Ti / RX 9070 XT',
            'fps.gpu.3': 'RTX 5090 / RX 9090 XT',
            'fps.res.1': '1080p (Full HD)',
            'fps.res.2': '1440p (WQHD)',
            'fps.res.3': '4K (UHD)',
            'fps.game.fps': 'Ego-Shooter (CS2, Valorant)',
            'fps.game.rts': 'Strategy (RTS)',
            'fps.game.aa': 'AAA Blockbuster',
            'fps.result': 'Estimated performance',
            'fps.empty': 'Select your components and estimate performance.',
            'fps.fps': 'FPS',
            'fps.rating.elite': 'ELITE – for pros',
            'fps.rating.high': 'Very smooth',
            'fps.rating.mid': 'Playable',
            'fps.rating.low': 'Not recommended',
            'fps.suggest': 'Recommended configuration',
            'fps.tier.1': 'Entry',
            'fps.tier.2': 'High-End',
            'fps.tier.3': 'Enthusiast',
            'fps.cta': 'Configure now',
        }
    };

    /* ===== State ===== */
    let currentLang = localStorage.getItem('iednex-lang') || 'de';
    if (!I18N[currentLang]) currentLang = 'de';

    const dict = () => I18N[currentLang];

    /* ===== i18n Core Functions ===== */
    function t(key) {
        return dict()[key] || I18N.de[key] || key;
    }

    function replacePlaceholders(str, data) {
        return str.replace(/\{\{(\w+)\}\}/g, (m, name) => (data[name] !== undefined ? data[name] : m));
    }

    function formatNumber(n) {
        return new Intl.NumberFormat(currentLang === 'de' ? 'de-DE' : 'en-US').format(n);
    }

    function formatPrice(n) {
        if (currentLang === 'de') return `${formatNumber(n)} €`;
        return `€${formatNumber(n)}`;
    }

    function formatFinance(n) {
        const monthly = Math.round(n / 24);
        return replacePlaceholders(t('ts.finance'), { price: formatNumber(monthly) });
    }

    function applyTranslations() {
        // Text content
        $$('[data-i18n]').forEach(el => {
            const key = el.dataset.i18n;
            el.textContent = t(key);
        });

        // Placeholders
        $$('[data-i18n-placeholder]').forEach(el => {
            el.placeholder = t(el.dataset.i18nPlaceholder);
        });

        // Prices (data-price)
        $$('[data-price]').forEach(el => {
            const price = parseInt(el.dataset.price, 10);
            if (isNaN(price)) return;
            if (el.classList.contains('price-finance') || el.dataset.i18nFinance) {
                el.textContent = formatFinance(price);
            } else {
                el.textContent = formatPrice(price);
            }
        });

        // Series prices with "from" prefix
        $$('[data-i18n-price]').forEach(el => {
            const price = parseInt(el.dataset.price, 10);
            if (isNaN(price)) return;
            el.textContent = replacePlaceholders(t(el.dataset.i18nPrice), { price: formatNumber(price) });
        });

        // html lang + title
        document.documentElement.lang = currentLang;
        document.title = t('html.title');

        // Language switcher active state
        $$('.lang-btn').forEach(btn => {
            btn.classList.toggle('active', btn.dataset.lang === currentLang);
        });

        // Refresh cart display (for finance strings & total)
        if (typeof renderCartItems === 'function') {
            renderCartItems();
        }
        if (typeof window.__renderComponents === 'function') {
            window.__renderComponents();
        }
        if (typeof window.__renderDeals === 'function') {
            window.__renderDeals();
        }
        if (typeof window.__renderFps === 'function') {
            window.__renderFps();
        }
        if (typeof window.__renderConfigurator === 'function') {
            window.__renderConfigurator();
        }
        if (typeof window.__renderProfile === 'function') {
            window.__renderProfile();
        }
    }

    function setLanguage(lang) {
        if (!I18N[lang]) return;
        currentLang = lang;
        localStorage.setItem('iednex-lang', lang);
        applyTranslations();

        // Persist the language preference on the logged-in user (if any).
        const sessUser = currentUser();
        if (sessUser) {
            const users = getUsers();
            const u = users.find(v => v.id === sessUser.id);
            if (u && u.lang !== lang) {
                u.lang = lang;
                saveUsers(users);
            }
        }
    }

    /* ===== Product Data (for cart) ===== */
    const PRODUCTS = {
        1:  { name: 'PHANTOM X - Ryzen 7 9800X3D / RTX 5080', price: 22999, icon: '🎮' },
        2:  { name: 'SPECTRE - Ryzen 7 9700X / RTX 5070 Ti', price: 16999, icon: '🎮' },
        3:  { name: 'TITAN X - Ryzen 7 9800X3D / RX 9070 XT', price: 19999, icon: '🖥️' },
        4:  { name: 'RAGNAR - Ryzen 9 9950X3D2 / RTX 5080', price: 26999, icon: '🎮' },
        5:  { name: 'FROST - Ryzen 7 9800X3D / RTX 5080 White', price: 27999, icon: '❄️' },
        6:  { name: 'BLADE 16 - Ryzen 9 980HX / RTX 5080', price: 24999, icon: '💻' },
        7:  { name: 'STRIKE 15 - Core Ultra 7 / RTX 5070', price: 14999, icon: '💻' },
        8:  { name: 'AERO 14 - Ryzen 9 9900HS / RTX 5060', price: 12999, icon: '💻' },
        9:  { name: 'FORGE W - Threadripper Pro / RTX Pro 6000', price: 89999, icon: '🖥️' },
        10: { name: 'FORGE X - Ryzen 9 9950X / Radeon AI Pro', price: 39999, icon: '🖥️' },
        // Hardware components (Thinkmate-style)
        101: { name: 'AMD Ryzen 9 9950X3D', price: 829, icon: '🧠' },
        102: { name: 'AMD Ryzen 7 9800X3D', price: 549, icon: '🧠' },
        103: { name: 'Intel Core Ultra 9 285K', price: 589, icon: '🧠' },
        104: { name: 'Intel Xeon W-3575', price: 3299, icon: '🧠' },
        201: { name: 'NVIDIA RTX 5090 32GB', price: 2999, icon: '🎮' },
        202: { name: 'NVIDIA RTX 5080 16GB', price: 1199, icon: '🎮' },
        203: { name: 'AMD Radeon RX 9070 XT', price: 899, icon: '🎮' },
        204: { name: 'NVIDIA RTX PRO 6000 96GB', price: 7999, icon: '🎮' },
        301: { name: 'Corsair Vengeance 32GB DDR5-6000', price: 129, icon: '⚡' },
        302: { name: 'G.Skill Trident Z5 64GB DDR5-6400', price: 279, icon: '⚡' },
        303: { name: 'Kingston FURY 128GB DDR5-5600 ECC', price: 649, icon: '⚡' },
        304: { name: 'Samsung 256GB DDR5-4800 RDIMM', price: 1899, icon: '⚡' },
        401: { name: 'Samsung 990 PRO 2TB NVMe', price: 189, icon: '💾' },
        402: { name: 'WD Black SN850X 4TB NVMe', price: 329, icon: '💾' },
        403: { name: 'Crucial T705 2TB PCIe 5.0', price: 329, icon: '💾' },
        404: { name: 'Kingston DC3000 7.68TB Enterprise', price: 899, icon: '💾' },
        501: { name: 'Seagate IronWolf Pro 8TB', price: 279, icon: '🗄️' },
        502: { name: 'WD Red Pro 16TB', price: 449, icon: '🗄️' },
        503: { name: 'Seagate Exos 20TB Enterprise', price: 599, icon: '🗄️' },
        504: { name: 'WD Gold 12TB', price: 379, icon: '🗄️' },
        601: { name: 'Fractal Design Meshify 2', price: 149, icon: '📦' },
        602: { name: 'Lian Li O11 Dynamic EVO', price: 169, icon: '📦' },
        603: { name: 'Silverstone RM51-308 4U Rack', price: 1099, icon: '📦' },
        604: { name: 'Fractal Design North XL', price: 199, icon: '📦' },
        701: { name: 'be quiet! Dark Power 13 1000W', price: 269, icon: '🔌' },
        702: { name: 'Seasonic Prime TX-1600', price: 449, icon: '🔌' },
        703: { name: 'APC Smart-UPS 1500VA', price: 799, icon: '🔌' },
        704: { name: 'CyberPower OL1500RTXL2U', price: 899, icon: '🔌' },
        801: { name: 'ASUS ROG Swift PG32UCDM', price: 1099, icon: '🖥️' },
        802: { name: 'Dell UltraSharp U2723QE', price: 499, icon: '🖥️' },
        803: { name: 'Samsung Odyssey G9 49"', price: 1199, icon: '🖥️' },
        804: { name: 'Eizo ColorEdge CG2700X', price: 1699, icon: '🖥️' },
        705: { name: 'Corsair AX1600i Digital 1600W', price: 579, icon: '🔌' },
        706: { name: 'ASUS ROG Thor III 1200W', price: 379, icon: '🔌' },
        707: { name: 'APC Smart-UPS 3000VA', price: 1599, icon: '🔋' },
        708: { name: 'Eaton 9PX 2200 RT2U', price: 1899, icon: '🔋' },
        // Deals & Specials
        901: { name: 'PHANTOM MESSE - Ryzen 7 9800X3D / RTX 5080', price: 18999, icon: '🎮' },
        902: { name: 'FORGE MESSE - Ryzen 9 9950X / RTX 5070 Ti', price: 21999, icon: '🖥️' },
        903: { name: 'BLADE MESSE - Ryzen 9 / RTX 5070', price: 11999, icon: '💻' },
        904: { name: 'KICK-ASS 01 - Ryzen 7 9700X / RTX 5070', price: 14999, icon: '⚡' },
        905: { name: 'KICK-ASS 02 - Ryzen 5 7500F / RTX 5060', price: 9999, icon: '⚡' },
        906: { name: 'KICK-ASS 03 - Ryzen 9 9950X3D / RTX 5080', price: 22999, icon: '⚡' },
        907: { name: 'REFURB AERO 14 - Ryzen 7 / RTX 5060', price: 8999, icon: '♻️' },
        908: { name: 'REFURB SPECTRE - Ryzen 7 9700X / RTX 5070 Ti', price: 11999, icon: '♻️' },
        909: { name: 'REFURB FORGE X - Ryzen 9 9950X / Radeon AI Pro', price: 25999, icon: '♻️' },
        // Cooling (configurator step 6)
        1001: { name: 'be quiet! Dark Rock Pro 5', price: 89, icon: '🌬️' },
        1002: { name: 'Noctua NH-D15 G2', price: 119, icon: '🌬️' },
        1003: { name: 'Corsair iCUE H150i Elite LCD XT 360', price: 249, icon: '🌬️' },
        1004: { name: 'Arctic Liquid Freezer III 420', price: 139, icon: '🌬️' },
    };

    /* ===== Component Data (Thinkmate-style) ===== */
    const COMPONENTS = [
        { id: 101, cat: 'cpu', brand: 'AMD', name: 'Ryzen 9 9950X3D', part: '100-000001490', icon: '🧠', price: 829, stock: 'in', tier: 3,
          specs: [['family','Ryzen 9000'],['socket','AM5'],['cores','16C/32T'],['boost','5.7 GHz'],['cache','128 MB 3D V-Cache']] },
        { id: 102, cat: 'cpu', brand: 'AMD', name: 'Ryzen 7 9800X3D', part: '100-000001397', icon: '🧠', price: 549, stock: 'in', tier: 2,
          specs: [['family','Ryzen 9000'],['socket','AM5'],['cores','8C/16T'],['boost','5.2 GHz'],['cache','96 MB 3D V-Cache']] },
        { id: 103, cat: 'cpu', brand: 'Intel', name: 'Core Ultra 9 285K', part: 'BX80768285K', icon: '🧠', price: 589, stock: 'low', tier: 2,
          specs: [['family','Core Ultra 200'],['socket','LGA1851'],['cores','24C/24T'],['boost','5.7 GHz'],['cache','36 MB']] },
        { id: 104, cat: 'cpu', brand: 'Intel', name: 'Xeon W-3575', part: 'PK8071305486100', icon: '🧠', price: 3299, stock: 'act', tier: 3,
          specs: [['family','Xeon W-3500'],['socket','LGA4677'],['cores','44C/88T'],['boost','4.8 GHz'],['cache','97.5 MB']] },
        { id: 201, cat: 'gpu', brand: 'NVIDIA', name: 'RTX 5090 32GB', part: 'VCNRTX5090', icon: '🎮', price: 2999, stock: 'in', tier: 3,
          specs: [['family','GeForce RTX 50'],['memory','32 GB GDDR7'],['bandwidth','1.79 TB/s'],['interface','PCIe 5.0 x16']] },
        { id: 202, cat: 'gpu', brand: 'NVIDIA', name: 'RTX 5080 16GB', part: 'VCNRTX5080', icon: '🎮', price: 1199, stock: 'in', tier: 2,
          specs: [['family','GeForce RTX 50'],['memory','16 GB GDDR7'],['bandwidth','960 GB/s'],['interface','PCIe 5.0 x16']] },
        { id: 203, cat: 'gpu', brand: 'AMD', name: 'Radeon RX 9070 XT', part: '113-412500000U', icon: '🎮', price: 899, stock: 'low', tier: 2,
          specs: [['family','Radeon RX 9000'],['memory','16 GB GDDR6'],['bandwidth','644 GB/s'],['interface','PCIe 5.0 x16']] },
        { id: 204, cat: 'gpu', brand: 'NVIDIA', name: 'RTX PRO 6000 Blackwell', part: 'VCNRTXPRO6000', icon: '🎮', price: 7999, stock: 'act', tier: 3,
          specs: [['family','RTX PRO'],['memory','96 GB GDDR7'],['bandwidth','1.8 TB/s'],['interface','PCIe 5.0 x16']] },
        { id: 301, cat: 'ram', brand: 'Corsair', name: 'Vengeance 32GB (2×16)', part: 'CMK32GX5M2B6000C30', icon: '⚡', price: 129, stock: 'in',
          specs: [['capacity','32 GB (2×16)'],['speed','DDR5-6000 CL30'],['form','DIMM']] },
        { id: 302, cat: 'ram', brand: 'G.Skill', name: 'Trident Z5 64GB (2×32)', part: 'F5-6400J3239G32GX2-TZ5RW', icon: '⚡', price: 279, stock: 'in',
          specs: [['capacity','64 GB (2×32)'],['speed','DDR5-6400 CL32'],['form','DIMM']] },
        { id: 303, cat: 'ram', brand: 'Kingston', name: 'FURY 128GB (4×32)', part: 'KF556E36VK8-128', icon: '⚡', price: 649, stock: 'low',
          specs: [['capacity','128 GB (4×32)'],['speed','DDR5-5600 ECC'],['form','DIMM']] },
        { id: 304, cat: 'ram', brand: 'Samsung', name: '256GB (8×32) RDIMM', part: 'M393A8G40AB2-CWE', icon: '⚡', price: 1899, stock: 'act',
          specs: [['capacity','256 GB (8×32)'],['speed','DDR5-4800 ECC'],['form','RDIMM']] },
        { id: 401, cat: 'ssd', brand: 'Samsung', name: '990 PRO 2TB', part: 'MZ-V9P2T0BW', icon: '💾', price: 189, stock: 'in',
          specs: [['capacity','2 TB'],['interface','NVMe PCIe 4.0'],['speed','7.45 GB/s'],['form','M.2 2280']] },
        { id: 402, cat: 'ssd', brand: 'WD', name: 'Black SN850X 4TB', part: 'WDS400T2X0E', icon: '💾', price: 329, stock: 'in',
          specs: [['capacity','4 TB'],['interface','NVMe PCIe 4.0'],['speed','7.3 GB/s'],['form','M.2 2280']] },
        { id: 403, cat: 'ssd', brand: 'Crucial', name: 'T705 2TB PCIe 5.0', part: 'CT2000T705SSD3', icon: '💾', price: 329, stock: 'low',
          specs: [['capacity','2 TB'],['interface','NVMe PCIe 5.0'],['speed','14.5 GB/s'],['form','M.2 2280']] },
        { id: 404, cat: 'ssd', brand: 'Kingston', name: 'DC3000 7.68TB Enterprise', part: 'SEDC3000ME/7680G', icon: '💾', price: 899, stock: 'act',
          specs: [['capacity','7.68 TB'],['interface','NVMe PCIe 4.0'],['speed','7.0 GB/s'],['form','U.2 2.5"']] },
        { id: 501, cat: 'hdd', brand: 'Seagate', name: 'IronWolf Pro 8TB', part: 'ST8000NE0004', icon: '🗄️', price: 279, stock: 'in',
          specs: [['capacity','8 TB'],['interface','SATA 6Gb/s'],['speed','7200 RPM'],['form','3.5"']] },
        { id: 502, cat: 'hdd', brand: 'WD', name: 'Red Pro 16TB', part: 'WD161KFGX', icon: '🗄️', price: 449, stock: 'in',
          specs: [['capacity','16 TB'],['interface','SATA 6Gb/s'],['speed','7200 RPM'],['form','3.5"']] },
        { id: 503, cat: 'hdd', brand: 'Seagate', name: 'Exos 20TB Enterprise', part: 'ST20000NM007D', icon: '🗄️', price: 599, stock: 'act',
          specs: [['capacity','20 TB'],['interface','SAS 12Gb/s'],['speed','7200 RPM'],['form','3.5"']] },
        { id: 504, cat: 'hdd', brand: 'WD', name: 'Gold 12TB', part: 'WD121KRYZ', icon: '🗄️', price: 379, stock: 'low',
          specs: [['capacity','12 TB'],['interface','SATA 6Gb/s'],['speed','7200 RPM'],['form','3.5"']] },
        { id: 601, cat: 'case', brand: 'Fractal Design', name: 'Meshify 2', part: 'FD-C-MES2A-04', icon: '📦', price: 149, stock: 'in',
          specs: [['family','Meshify'],['form','Mid-Tower'],['size','ATX / E-ATX']] },
        { id: 602, cat: 'case', brand: 'Lian Li', name: 'O11 Dynamic EVO', part: 'G99-O11DEVO-W', icon: '📦', price: 169, stock: 'in',
          specs: [['family','O11'],['form','Mid-Tower'],['size','ATX']] },
        { id: 603, cat: 'case', brand: 'Silverstone', name: 'RM51-308 4U Rack', part: 'RM51-308-3E2', icon: '📦', price: 1099, stock: 'act',
          specs: [['family','RM51'],['form','Rack 4U'],['size','E-ATX / SSI-EEB']] },
        { id: 604, cat: 'case', brand: 'Fractal Design', name: 'North XL', part: 'FD-C-NOR1X-01', icon: '📦', price: 199, stock: 'low',
          specs: [['family','North'],['form','Full-Tower'],['size','E-ATX']] },
        { id: 701, cat: 'psu', brand: 'be quiet!', name: 'Dark Power 13 1000W', part: 'BN652', icon: '🔌', price: 269, stock: 'in',
          specs: [['family','Dark Power 13'],['watt','1000 W'],['form','ATX 3.0']] },
        { id: 702, cat: 'psu', brand: 'Seasonic', name: 'Prime TX-1600', part: 'SSR-1600TR', icon: '🔌', price: 449, stock: 'in',
          specs: [['family','Prime TX'],['watt','1600 W'],['form','ATX 3.0']] },
        { id: 705, cat: 'psu', brand: 'Corsair', name: 'AX1600i Digital', part: 'CP-9020110-UK', icon: '🔌', price: 579, stock: 'in',
          specs: [['family','AX Series'],['watt','1600 W'],['form','ATX 3.0 / 80+ Titanium']] },
        { id: 706, cat: 'psu', brand: 'ASUS', name: 'ROG Thor III 1200W', part: '90DC00K0-B19000', icon: '🔌', price: 379, stock: 'low',
          specs: [['family','ROG Thor'],['watt','1200 W'],['form','ATX 3.1 / 80+ Platinum']] },
        { id: 703, cat: 'ups', brand: 'APC', name: 'Smart-UPS 1500VA', part: 'SMT1500I', icon: '🔋', price: 799, stock: 'act',
          specs: [['family','Smart-UPS'],['watt','1500 VA / 900 W'],['form','Tower'],['interface','USB / Netzwerk']] },
        { id: 704, cat: 'ups', brand: 'CyberPower', name: 'OL1500RTXL2U', part: 'OL1500RTXL2U', icon: '🔋', price: 899, stock: 'act',
          specs: [['family','OL Series'],['watt','1500 VA / 1350 W'],['form','Rack 2U'],['interface','USB / SNMP']] },
        { id: 707, cat: 'ups', brand: 'APC', name: 'Smart-UPS 3000VA', part: 'SMT3000I', icon: '🔋', price: 1599, stock: 'in',
          specs: [['family','Smart-UPS'],['watt','3000 VA / 2700 W'],['form','Tower / Rack 2U'],['interface','USB / Netzwerk']] },
        { id: 708, cat: 'ups', brand: 'Eaton', name: '9PX 2200 RT2U', part: '9PX2200RT', icon: '🔋', price: 1899, stock: 'act',
          specs: [['family','9PX Series'],['watt','2200 VA / 1980 W'],['form','Rack 2U'],['interface','USB / Netzwerk / SNMP']] },
        { id: 801, cat: 'monitor', brand: 'ASUS', name: 'ROG Swift PG32UCDM', part: '90LM09G0-B01170', icon: '🖥️', price: 1099, stock: 'in',
          specs: [['size','32"'],['panel','QD-OLED'],['resolution','3840×2160'],['refresh','240 Hz']] },
        { id: 802, cat: 'monitor', brand: 'Dell', name: 'UltraSharp U2723QE', part: 'DELL-U2723QE', icon: '🖥️', price: 499, stock: 'in',
          specs: [['size','27"'],['panel','IPS Black'],['resolution','3840×2160'],['refresh','60 Hz']] },
        { id: 803, cat: 'monitor', brand: 'Samsung', name: 'Odyssey G9 49"', part: 'LS49CG932SUXEN', icon: '🖥️', price: 1199, stock: 'low',
          specs: [['size','49"'],['panel','QD-OLED'],['resolution','5120×1440'],['refresh','240 Hz']] },
        { id: 804, cat: 'monitor', brand: 'Eizo', name: 'ColorEdge CG2700X', part: 'CG2700X-BK', icon: '🖥️', price: 1699, stock: 'act',
          specs: [['size','27"'],['panel','IPS'],['resolution','2560×1440'],['refresh','60 Hz']] },
        // Cooling (configurator step 6)
        { id: 1001, cat: 'cooler', brand: 'be quiet!', name: 'Dark Rock Pro 5', part: 'BK037', icon: '🌬️', price: 89, stock: 'in',
          specs: [['type','Air'],['tdp','270 W'],['form','Tower'],['socket','AM5 / LGA1851']] },
        { id: 1002, cat: 'cooler', brand: 'Noctua', name: 'NH-D15 G2', part: 'NH-D15G2', icon: '🌬️', price: 119, stock: 'in',
          specs: [['type','Air'],['tdp','300 W'],['form','Tower'],['socket','AM5 / LGA1851']] },
        { id: 1003, cat: 'cooler', brand: 'Corsair', name: 'iCUE H150i Elite LCD XT 360', part: 'CW-9060061-WW', icon: '🌬️', price: 249, stock: 'in',
          specs: [['type','Liquid'],['tdp','420 W'],['form','360 mm'],['socket','AM5 / LGA1851']] },
        { id: 1004, cat: 'cooler', brand: 'Arctic', name: 'Liquid Freezer III 420', part: 'ACFRE00132A', icon: '🌬️', price: 139, stock: 'low',
          specs: [['type','Liquid'],['tdp','450 W'],['form','420 mm'],['socket','AM5 / LGA1851']] },
    ];

    /* ===== Language Switcher ===== */
    function initLangSwitcher() {
        $$('.lang-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                setLanguage(btn.dataset.lang);
            });
        });
    }

    /* ===== Top Bar Slider ===== */
    function initTopBarSlider() {
        const items = $$('.top-bar-item');
        if (items.length <= 1) return;

        let current = 0;
        setInterval(() => {
            items[current].classList.remove('active');
            current = (current + 1) % items.length;
            items[current].classList.add('active');
        }, 4000);
    }

    /* ===== Header Scroll Effect ===== */
    function initHeaderScroll() {
        const header = $('#header');
        const backToTop = $('#backToTop');

        window.addEventListener('scroll', () => {
            const scrolled = window.scrollY > 50;

            if (scrolled) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }

            if (window.scrollY > 600) {
                backToTop.classList.add('active');
            } else {
                backToTop.classList.remove('active');
            }
        });

        backToTop.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }

    /* ===== Mobile Menu ===== */
    function initMobileMenu() {
        const toggle = $('#mobileMenuToggle');
        const nav = $('#mainNav');
        const overlay = document.createElement('div');
        overlay.className = 'mobile-nav-overlay';
        document.body.appendChild(overlay);

        function toggleMenu() {
            toggle.classList.toggle('active');
            nav.classList.toggle('active');
            overlay.classList.toggle('active');
            document.body.style.overflow = nav.classList.contains('active') ? 'hidden' : '';
        }

        toggle.addEventListener('click', toggleMenu);
        overlay.addEventListener('click', toggleMenu);

        // Close on nav link click
        $$('.nav-item > a').forEach(link => {
            link.addEventListener('click', (e) => {
                if (window.innerWidth <= 900 && link.parentElement.classList.contains('has-dropdown')) {
                    e.preventDefault();
                    link.parentElement.classList.toggle('expanded');
                    return;
                }
                if (window.innerWidth <= 900) {
                    toggleMenu();
                }
            });
        });
    }

    /* ===== Search Toggle ===== */
    function initSearch() {
        const toggle = $('#searchToggle');
        const close = $('#searchClose');
        const bar = $('#searchBar');
        const input = $('#searchInput');

        toggle.addEventListener('click', () => {
            bar.classList.add('active');
            setTimeout(() => input.focus(), 100);
        });

        close.addEventListener('click', () => {
            bar.classList.remove('active');
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && bar.classList.contains('active')) {
                bar.classList.remove('active');
            }
        });
    }

    /* ===== Hero Carousel ===== */
    function initHeroCarousel() {
        const slides = $$('.hero-slide');
        const dots = $$('.hero-dot');
        const prev = $('#heroPrev');
        const next = $('#heroNext');

        if (slides.length === 0) return;

        let current = 0;
        let autoSlide;

        function goTo(index) {
            slides[current].classList.remove('active');
            dots[current].classList.remove('active');
            current = (index + slides.length) % slides.length;
            slides[current].classList.add('active');
            dots[current].classList.add('active');
        }

        function nextSlide() { goTo(current + 1); }
        function prevSlide() { goTo(current - 1); }

        function startAuto() {
            autoSlide = setInterval(nextSlide, 6000);
        }

        function stopAuto() {
            clearInterval(autoSlide);
        }

        function restartAuto() {
            stopAuto();
            startAuto();
        }

        dots.forEach(dot => {
            dot.addEventListener('click', () => {
                goTo(parseInt(dot.dataset.slide));
                restartAuto();
            });
        });

        next.addEventListener('click', () => { nextSlide(); restartAuto(); });
        prev.addEventListener('click', () => { prevSlide(); restartAuto(); });

        const hero = $('.hero');
        hero.addEventListener('mouseenter', stopAuto);
        hero.addEventListener('mouseleave', startAuto);

        let touchStartX = 0;
        hero.addEventListener('touchstart', (e) => {
            touchStartX = e.touches[0].clientX;
        }, { passive: true });

        hero.addEventListener('touchend', (e) => {
            const diff = touchStartX - e.changedTouches[0].clientX;
            if (Math.abs(diff) > 50) {
                if (diff > 0) nextSlide();
                else prevSlide();
                restartAuto();
            }
        }, { passive: true });

        startAuto();
    }

    /* ===== Highlights Carousel ===== */
    function initHighlightsCarousel() {
        const cards = $$('.highlight-card');
        const dots = $$('.hi-dot');

        if (cards.length === 0) return;

        let current = 0;
        let autoHi;

        function goTo(index) {
            cards[current].classList.remove('active');
            dots[current].classList.remove('active');
            current = (index + cards.length) % cards.length;
            cards[current].classList.add('active');
            dots[current].classList.add('active');
        }

        dots.forEach(dot => {
            dot.addEventListener('click', () => {
                goTo(parseInt(dot.dataset.hi));
            });
        });

        autoHi = setInterval(() => {
            goTo(current + 1);
        }, 5000);

        const container = $('#highlightsCarousel');
        if (container) {
            container.addEventListener('mouseenter', () => clearInterval(autoHi));
            container.addEventListener('mouseleave', () => {
                autoHi = setInterval(() => goTo(current + 1), 5000);
            });
        }
    }

    /* ===== Configurator Tabs ===== */
    function initConfigTabs() {
        const tabs = $$('.config-tab');
        const panels = $$('.config-panel');

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const target = tab.dataset.tab;

                tabs.forEach(t => t.classList.remove('active'));
                panels.forEach(p => p.classList.remove('active'));

                tab.classList.add('active');
                const panel = $(`.config-panel[data-panel="${target}"]`);
                if (panel) panel.classList.add('active');
            });
        });
    }

    /* ===== Topseller Tabs ===== */
    function initTopsellerTabs() {
        const tabs = $$('.topseller-tab');
        const panels = $$('.topseller-panel');

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const target = tab.dataset.ttab;

                tabs.forEach(t => t.classList.remove('active'));
                panels.forEach(p => p.classList.remove('active'));

                tab.classList.add('active');
                const panel = $(`.topseller-panel[data-tpanel="${target}"]`);
                if (panel) panel.classList.add('active');
            });
        });
    }

    /* ===== Hardware Components (Thinkmate-style) ===== */
    let currentCompCat = 'cpu';
    let compareList = [];

    function initComponents() {
        const tabsEl = $('#compTabs');
        const gridEl = $('#compGrid');
        const barEl = $('#compareBar');
        const thumbsEl = $('#compareThumbs');
        const btnEl = $('#compareBtn');
        const clearEl = $('#compareClear');
        const modalEl = $('#compareModal');
        const tableEl = $('#compareTable');
        const modalClose = $('#compareModalClose');

        const CATS = ['cpu', 'gpu', 'ram', 'ssd', 'hdd', 'case', 'psu', 'monitor', 'ups', 'cooler'];

        function stockLabel(s) { return t('comp.stock.' + s); }

        function renderTabs() {
            tabsEl.innerHTML = '';
            CATS.forEach(cat => {
                const btn = document.createElement('button');
                btn.className = 'comp-tab' + (cat === currentCompCat ? ' active' : '');
                btn.dataset.cat = cat;
                const parts = t('comp.cat.' + cat).split(' ');
                const abbr = parts.shift();
                btn.innerHTML = abbr + (parts.length ? ' <small>' + parts.join(' ') + '</small>' : '');
                btn.addEventListener('click', () => {
                    currentCompCat = cat;
                    renderTabs();
                    renderCards();
                });
                tabsEl.appendChild(btn);
            });
        }

        function renderCards() {
            const items = COMPONENTS.filter(c => c.cat === currentCompCat);
            gridEl.innerHTML = '';
            items.forEach(c => {
                const card = document.createElement('div');
                card.className = 'comp-card' + (compareList.includes(c.id) ? ' comp-selected' : '');
                card.innerHTML = `
                    <div class="comp-head">
                        <span class="comp-brand">${c.brand}</span>
                        <span class="comp-icon">${c.icon}</span>
                    </div>
                    <h3 class="comp-name">${c.name}</h3>
                    <div class="comp-part">${t('comp.spec.part')}: ${c.part}</div>
                    <ul class="comp-specs">
                        ${c.specs.map(([k, v]) => `<li><span>${t('comp.spec.' + k)}</span><strong>${v}</strong></li>`).join('')}
                    </ul>
                    <div class="comp-foot">
                        <div class="comp-price">${formatPrice(c.price)}</div>
                        <span class="comp-stock ${c.stock}">${stockLabel(c.stock)}</span>
                    </div>
                    <div class="comp-actions">
                        <button class="comp-compare-toggle${compareList.includes(c.id) ? ' active' : ''}" data-id="${c.id}" title="Compare">⇄</button>
                        <button class="comp-add" data-id="${c.id}">${t('comp.add')}</button>
                    </div>
                `;
                gridEl.appendChild(card);
            });

            $$('.comp-compare-toggle', gridEl).forEach(b => {
                b.addEventListener('click', () => toggleCompare(parseInt(b.dataset.id)));
            });
            $$('.comp-add', gridEl).forEach(b => {
                b.addEventListener('click', () => {
                    if (IEDNEX_WC) { window.location.href = IEDNEX_WC_URL; return; }
                    const id = parseInt(b.dataset.id);
                    cart.push({ id });
                    renderCartItems();
                    const original = b.textContent;
                    b.textContent = t('comp.added');
                    b.disabled = true;
                    setTimeout(() => { b.textContent = original; b.disabled = false; }, 1500);
                });
            });
        }

        function toggleCompare(id) {
            const idx = compareList.indexOf(id);
            if (idx >= 0) {
                compareList.splice(idx, 1);
            } else {
                if (compareList.length >= 4) {
                    showToast(t('comp.maxCompare'));
                    return;
                }
                compareList.push(id);
            }
            renderCards();
            renderCompareBar();
        }

        function renderCompareBar() {
            thumbsEl.innerHTML = '';
            compareList.forEach(id => {
                const c = COMPONENTS.find(x => x.id === id);
                const thumb = document.createElement('div');
                thumb.className = 'compare-thumb';
                thumb.innerHTML = `${c.icon} ${c.brand} ${c.name} <button data-rid="${id}">✕</button>`;
                thumb.querySelector('button').addEventListener('click', () => {
                    compareList = compareList.filter(x => x !== id);
                    renderCards();
                    renderCompareBar();
                });
                thumbsEl.appendChild(thumb);
            });
            barEl.classList.toggle('active', compareList.length > 0);
            btnEl.disabled = compareList.length < 2;
        }

        function renderCompareTable() {
            const items = compareList.map(id => COMPONENTS.find(c => c.id === id));
            const fixedRows = ['brand', 'model', 'part', 'price', 'stock'];
            const specKeys = [];
            items.forEach(c => c.specs.forEach(([k]) => { if (!specKeys.includes(k)) specKeys.push(k); }));

            let html = '<thead><tr><th></th>' + items.map(c =>
                `<th>${c.brand} ${c.name}<small>${t('comp.spec.part')}: ${c.part}</small></th>`).join('') + '</tr></thead><tbody>';

            fixedRows.forEach(r => {
                html += `<tr><th>${t('comp.spec.' + r)}</th>` + items.map(c => {
                    if (r === 'brand') return `<td>${c.brand}</td>`;
                    if (r === 'model') return `<td>${c.name}</td>`;
                    if (r === 'part') return `<td>${c.part}</td>`;
                    if (r === 'price') return `<td class="comp-price">${formatPrice(c.price)}</td>`;
                    return `<td><span class="compare-badge ${c.stock}">${stockLabel(c.stock)}</span></td>`;
                }).join('') + '</tr>';
            });

            specKeys.forEach(k => {
                html += `<tr><th>${t('comp.spec.' + k)}</th>` + items.map(c => {
                    const f = c.specs.find(s => s[0] === k);
                    return `<td>${f ? f[1] : '—'}</td>`;
                }).join('') + '</tr>';
            });
            html += '</tbody>';
            tableEl.innerHTML = html;
        }

        function openModal() {
            if (compareList.length < 2) return;
            renderCompareTable();
            modalEl.classList.add('active');
            document.body.style.overflow = 'hidden';
        }
        function closeModal() {
            modalEl.classList.remove('active');
            document.body.style.overflow = '';
        }

        btnEl.addEventListener('click', openModal);
        modalClose.addEventListener('click', closeModal);
        modalEl.addEventListener('click', (e) => { if (e.target === modalEl) closeModal(); });
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeModal(); });
        clearEl.addEventListener('click', () => {
            compareList = [];
            renderCards();
            renderCompareBar();
        });

        window.__renderComponents = () => { renderTabs(); renderCards(); renderCompareBar(); };

        renderTabs();
        renderCards();
    }

    /* ===== Deals & Specials (MIFCOM-style) ===== */
    const DEALS = {
        messe: [
            { id: 901, icon: '🎮', name: 'PHANTOM MESSE – Ryzen 7 9800X3D / RTX 5080',
              specs: [['cpu','AMD Ryzen 7 9800X3D'],['gpu','RTX 5080 16GB'],['ram','32GB DDR5-6000'],['storage','2TB NVMe SSD']], price: 18999, old: 22999, pct: 17, limited: true },
            { id: 902, icon: '🖥️', name: 'FORGE MESSE – Ryzen 9 9950X / RTX 5070 Ti',
              specs: [['cpu','AMD Ryzen 9 9950X'],['gpu','RTX 5070 Ti 16GB'],['ram','64GB DDR5-6000'],['storage','2TB NVMe SSD']], price: 21999, old: 25999, pct: 15, limited: true },
            { id: 903, icon: '💻', name: 'BLADE MESSE – Ryzen 9 / RTX 5070',
              specs: [['cpu','AMD Ryzen 9 980HX'],['gpu','RTX 5070 8GB'],['ram','32GB DDR5-5600'],['storage','1TB NVMe SSD']], price: 11999, old: 14999, pct: 20, limited: true },
        ],
        kickass: [
            { id: 904, icon: '⚡', name: 'KICK-ASS 01 – Ryzen 7 9700X / RTX 5070',
              specs: [['cpu','AMD Ryzen 7 9700X'],['gpu','RTX 5070 Ti 16GB'],['ram','32GB DDR5-6000'],['storage','1TB NVMe SSD']], price: 14999, old: 16999, pct: 12 },
            { id: 905, icon: '⚡', name: 'KICK-ASS 02 – Ryzen 5 7500F / RTX 5060',
              specs: [['cpu','AMD Ryzen 5 7500F'],['gpu','RTX 5060 8GB'],['ram','32GB DDR5-6000'],['storage','1TB NVMe SSD']], price: 9999, old: 11999, pct: 17 },
            { id: 906, icon: '⚡', name: 'KICK-ASS 03 – Ryzen 9 9950X3D / RTX 5080',
              specs: [['cpu','AMD Ryzen 9 9950X3D'],['gpu','RTX 5080 16GB'],['ram','64GB DDR5-6000'],['storage','2TB NVMe SSD']], price: 22999, old: 26999, pct: 15 },
        ],
        refurb: [
            { id: 907, icon: '♻️', name: 'REFURB AERO 14 – Ryzen 7 / RTX 5060',
              specs: [['cpu','AMD Ryzen 7 8845HS'],['gpu','RTX 5060 8GB'],['ram','32GB DDR5'],['storage','1TB NVMe SSD']], price: 8999, old: 12999, pct: 31, refurb: true },
            { id: 908, icon: '♻️', name: 'REFURB SPECTRE – Ryzen 7 9700X / RTX 5070 Ti',
              specs: [['cpu','AMD Ryzen 7 9700X'],['gpu','RTX 5070 Ti 16GB'],['ram','32GB DDR5-6000'],['storage','1TB NVMe SSD']], price: 11999, old: 16999, pct: 29, refurb: true },
            { id: 909, icon: '♻️', name: 'REFURB FORGE X – Ryzen 9 9950X / Radeon AI Pro',
              specs: [['cpu','AMD Ryzen 9 9950X'],['gpu','Radeon AI Pro R9700'],['ram','64GB DDR5'],['storage','2TB NVMe SSD']], price: 25999, old: 39999, pct: 35, refurb: true },
        ],
    };

    function initDeals() {
        const tabsEl = $('#dealsTabs');
        const gridEl = $('#dealsGrid');
        const CATS = ['messe', 'kickass', 'refurb'];
        let currentDealCat = 'messe';

        function renderTabs() {
            tabsEl.innerHTML = '';
            CATS.forEach(cat => {
                const btn = document.createElement('button');
                btn.className = 'deals-tab' + (cat === currentDealCat ? ' active' : '');
                btn.dataset.cat = cat;
                btn.textContent = t('deals.tab.' + cat);
                btn.addEventListener('click', () => {
                    currentDealCat = cat;
                    renderTabs();
                    renderCards();
                });
                tabsEl.appendChild(btn);
            });
        }

        function renderCards() {
            const items = DEALS[currentDealCat];
            gridEl.innerHTML = items.map(d => `
                <div class="deal-card">
                    <div class="deal-badges">
                        <span class="deal-pct">-${d.pct}%</span>
                        ${d.refurb
                            ? '<span class="deal-tag refurb">♻ ' + t('deals.refurbBadge') + '</span>'
                            : (d.limited ? '<span class="deal-tag">⏳ ' + t('deals.limited') + '</span>' : '')}
                    </div>
                    <div class="deal-icon">${d.icon}</div>
                    <h3 class="deal-name">${d.name}</h3>
                    <ul class="deal-specs">${d.specs.map(([k, v]) => `<li><span>${t('spec.' + k)}</span><strong>${v}</strong></li>`).join('')}</ul>
                    <div class="deal-price-row">
                        <span class="deal-price-old">${formatPrice(d.old)}</span>
                        <span class="deal-price">${formatPrice(d.price)}</span>
                        <span class="deal-saving">${t('deals.saving')} ${formatPrice(d.old - d.price)}</span>
                    </div>
                    <button class="deal-btn" data-id="${d.id}">${t('deals.add')}</button>
                </div>`).join('');

            $$('.deal-btn', gridEl).forEach(b => {
                b.addEventListener('click', () => {
                    if (IEDNEX_WC) { window.location.href = IEDNEX_WC_URL; return; }
                    const id = parseInt(b.dataset.id);
                    cart.push({ id });
                    renderCartItems();
                    const original = b.textContent;
                    b.textContent = t('deals.added');
                    b.disabled = true;
                    setTimeout(() => { b.textContent = original; b.disabled = false; }, 1500);
                });
            });
        }

        window.__renderDeals = () => { renderTabs(); renderCards(); };

        renderTabs();
        renderCards();
    }

    /* ===== FPS Checker (MIFCOM-style) ===== */
    const FPS_OPTS = {
        cpu:  { 1: { label: 'fps.cpu.1', sub: '6C/12T' }, 2: { label: 'fps.cpu.2', sub: '8C/16T' }, 3: { label: 'fps.cpu.3', sub: '16C/32T' } },
        gpu:  { 1: { label: 'fps.gpu.1', sub: 'fps.tier.1' }, 2: { label: 'fps.gpu.2', sub: 'fps.tier.2' }, 3: { label: 'fps.gpu.3', sub: 'fps.tier.3' } },
        res:  { 1: { label: 'fps.res.1' }, 2: { label: 'fps.res.2' }, 3: { label: 'fps.res.3' } },
        game: { fps: { label: 'fps.game.fps' }, rts: { label: 'fps.game.rts' }, aa: { label: 'fps.game.aa' } },
    };
    const FPS_BASE = {
        1: { 1: 190, 2: 140, 3: 75 },
        2: { 1: 270, 2: 200, 3: 110 },
        3: { 1: 380, 2: 280, 3: 160 },
    };
    const FPS_GAME = { fps: 1.0, rts: 0.8, aa: 0.55 };
    const FPS_CPU = { 1: 0.9, 2: 1.0, 3: 1.08 };

    /* Shared estimate: used by the FPS-Checker AND the configurator summary. */
    function estimateFps(cpuTier, gpuTier, res = 2, game = 'fps') {
        const base = FPS_BASE[gpuTier] && FPS_BASE[gpuTier][res] ? FPS_BASE[gpuTier][res] : 0;
        return Math.round(base * (FPS_GAME[game] || 1) * (FPS_CPU[cpuTier] || 1));
    }

    function fpsRatingOf(fps) {
        let rating, pct;
        if (fps >= 240) { rating = 'elite'; pct = Math.min(100, fps / 380 * 100); }
        else if (fps >= 144) { rating = 'high'; pct = fps / 380 * 100; }
        else if (fps >= 60) { rating = 'mid'; pct = fps / 380 * 100; }
        else { rating = 'low'; pct = Math.max(8, fps / 380 * 100); }
        return { rating, pct };
    }

    function initFpsChecker() {
        const controlsEl = $('#fpsControls');
        const resultEl = $('#fpsResult');
        const state = { cpu: 2, gpu: 2, res: 2, game: 'fps' };

        function renderControls() {
            controlsEl.innerHTML = Object.keys(FPS_OPTS).map(g => `
                <div class="fps-group">
                    <label>${t('fps.' + g)}</label>
                    <div class="fps-opts">
                        ${Object.keys(FPS_OPTS[g]).map(k => {
                            const opt = FPS_OPTS[g][k];
                            const sub = opt.sub ? `<small>${t(opt.sub)}</small>` : '';
                            return `<button class="fps-opt${String(state[g]) === k ? ' active' : ''}" data-g="${g}" data-k="${k}">${t(opt.label)}${sub}</button>`;
                        }).join('')}
                    </div>
                </div>`).join('');

            $$('.fps-opt', controlsEl).forEach(b => {
                b.addEventListener('click', () => {
                    state[b.dataset.g] = b.dataset.g === 'game' ? b.dataset.k : parseInt(b.dataset.k);
                    renderControls();
                    renderResult();
                });
            });
        }

        function renderResult() {
            const fps = estimateFps(state.cpu, state.gpu, state.res, state.game);
            const { rating, pct } = fpsRatingOf(fps);

            let suggestKey;
            if (fps >= 144) suggestKey = 'fps.gpu.' + state.gpu;
            else if (fps >= 60) suggestKey = state.gpu >= 2 ? 'fps.gpu.' + state.gpu : 'fps.gpu.2';
            else suggestKey = 'fps.gpu.3';

            resultEl.innerHTML = `
                <div class="fps-score">${fps}<span class="fps-score-unit"> ${t('fps.fps')}</span></div>
                <div class="fps-rating ${rating}">${t('fps.rating.' + rating)}</div>
                <div class="fps-bar"><div class="fps-bar-fill" style="width:${pct}%"></div></div>
                <div class="fps-suggest">${t('fps.suggest')}: <strong>${t(suggestKey)}</strong></div>
                <a class="fps-cta" href="#configurator">${t('fps.cta')}</a>`;
        }

        window.__renderFps = () => { renderControls(); renderResult(); };

        renderControls();
        renderResult();
    }

    /* ===== Step-by-Step PC Configurator ===== */
    const CONFIG_STEPS = [
        { key: 'cpu',     cat: ['cpu'],          icon: '🧠' },
        { key: 'gpu',     cat: ['gpu'],          icon: '🎮' },
        { key: 'ram',     cat: ['ram'],          icon: '⚡' },
        { key: 'storage', cat: ['ssd', 'hdd'],   icon: '💾' },
        { key: 'case',    cat: ['case'],         icon: '📦' },
        { key: 'cooler',  cat: ['cooler'],       icon: '🌬️' },
    ];
    let configStep = 0;
    let configSel = {};

    function initConfigurator() {
        const stepperEl = $('#cfgStepper');
        if (!stepperEl) return;

        const optionsEl = $('#cfgOptions');
        const summaryEl = $('#cfgSummary');
        const backBtn = $('#cfgBack');
        const nextBtn = $('#cfgNext');
        const hintEl = $('#cfgNavHint');
        const nextSpan = nextBtn.querySelector('span');

        // Restore previous selection from localStorage.
        try {
            const saved = JSON.parse(localStorage.getItem('iednex-config') || '{}');
            if (saved && typeof saved === 'object') {
                CONFIG_STEPS.forEach(s => {
                    const id = saved[s.key];
                    if (id && COMPONENTS.some(c => c.id === id)) configSel[s.key] = id;
                });
            }
        } catch (e) { /* ignore corrupted storage */ }

        function save() {
            try { localStorage.setItem('iednex-config', JSON.stringify(configSel)); } catch (e) {}
        }

        function render() {
            renderStepper();
            renderOptions();
            renderSummary();
            renderNavHint();
            nextSpan.textContent = configStep === CONFIG_STEPS.length - 1 ? t('cfg.addOrder') : t('cfg.next');
        }

        function renderStepper() {
            stepperEl.innerHTML = CONFIG_STEPS.map((s, i) => `
                <button class="cfg-step${i === configStep ? ' active' : ''}${configSel[s.key] ? ' done' : ''}" data-step="${i}" type="button">
                    <span class="cfg-step-num">${configSel[s.key] ? '✓' : (i + 1)}</span>
                    <span class="cfg-step-label">${t('cfg.step.' + s.key)}</span>
                </button>`).join('');
            $$('.cfg-step', stepperEl).forEach(b => {
                b.addEventListener('click', () => {
                    configStep = parseInt(b.dataset.step);
                    render();
                });
            });
        }

        function renderOptions() {
            const step = CONFIG_STEPS[configStep];
            const items = COMPONENTS.filter(c => step.cat.includes(c.cat));
            optionsEl.innerHTML = `
                <div class="cfg-step-head">
                    <h3><span class="cfg-step-icon">${step.icon}</span> ${t('cfg.step.' + step.key)}</h3>
                    <p>${t('cfg.step.' + step.key + '.d')}</p>
                </div>
                <div class="cfg-opt-grid">
                    ${items.map(c => {
                        const sel = configSel[step.key] === c.id;
                        const tier = c.tier ? `<div class="cfg-tier">${t('fps.tier.' + c.tier)}</div>` : '';
                        return `<button class="comp-card cfg-opt${sel ? ' cfg-selected' : ''}" data-id="${c.id}" type="button">
                            <div class="comp-head">
                                <span class="comp-brand">${c.brand}</span>
                                <span class="comp-icon">${c.icon}</span>
                            </div>
                            <h3 class="comp-name">${c.name}</h3>
                            <div class="comp-part">${t('comp.spec.part')}: ${c.part}</div>
                            <ul class="comp-specs">
                                ${c.specs.map(([k, v]) => `<li><span>${t('comp.spec.' + k)}</span><strong>${v}</strong></li>`).join('')}
                            </ul>
                            <div class="comp-foot">
                                <div class="comp-price">${formatPrice(c.price)}</div>
                                <span class="comp-stock ${c.stock}">${t('comp.stock.' + c.stock)}</span>
                            </div>
                            ${tier}
                            <div class="cfg-opt-check">${sel ? '✓' : ''}</div>
                        </button>`;
                    }).join('')}
                </div>`;
            $$('.cfg-opt', optionsEl).forEach(b => {
                b.addEventListener('click', () => {
                    configSel[step.key] = parseInt(b.dataset.id);
                    save();
                    if (configStep < CONFIG_STEPS.length - 1) {
                        configStep++;
                        render();
                    } else {
                        render();
                        showToast(t('cfg.step.done'));
                    }
                });
            });
        }

        function renderSummary() {
            let total = 0;
            const rows = CONFIG_STEPS.map((s, i) => {
                const id = configSel[s.key];
                const p = id ? COMPONENTS.find(c => c.id === id) : null;
                if (p) total += p.price;
                return `<div class="cfg-s-row${p ? '' : ' cfg-s-empty'}">
                    <span class="cfg-s-icon">${s.icon}</span>
                    <div class="cfg-s-info">
                        <span class="cfg-s-cat">${t('cfg.step.' + s.key)}</span>
                        <strong class="cfg-s-name">${p ? p.brand + ' ' + p.name : t('cfg.none')}</strong>
                    </div>
                    <span class="cfg-s-price">${p ? formatPrice(p.price) : '—'}</span>
                    ${p ? `<button class="cfg-s-remove" data-step="${i}" title="${t('cfg.remove')}" type="button">✕</button>` : ''}
                </div>`;
            }).join('');

            const cpu = configSel.cpu ? COMPONENTS.find(c => c.id === configSel.cpu) : null;
            const gpu = configSel.gpu ? COMPONENTS.find(c => c.id === configSel.gpu) : null;
            let perfHtml;
            if (cpu && gpu) {
                const fps = estimateFps(cpu.tier || 2, gpu.tier || 2, 2, 'fps');
                const { rating, pct } = fpsRatingOf(fps);
                perfHtml = `
                    <div class="cfg-perf">
                        <div class="cfg-perf-label">${t('cfg.perf')}</div>
                        <div class="fps-score">${fps}<span class="fps-score-unit"> ${t('fps.fps')}</span></div>
                        <div class="fps-rating ${rating}">${t('fps.rating.' + rating)}</div>
                        <div class="fps-bar"><div class="fps-bar-fill" style="width:${pct}%"></div></div>
                        <div class="cfg-perf-note">${t('cfg.perf.note')}</div>
                    </div>`;
            } else {
                perfHtml = `<div class="cfg-perf cfg-perf-hint">${t('cfg.perf.hint')}</div>`;
            }

            summaryEl.innerHTML = `
                <h3 class="cfg-summary-title">${t('cfg.summary')}</h3>
                <div class="cfg-s-list">${rows}</div>
                ${perfHtml}
                <div class="cfg-total">
                    <span>${t('cfg.total')}</span>
                    <strong>${formatPrice(total)}</strong>
                </div>
                <button class="btn btn-primary btn-block cfg-add-order" id="cfgAddOrder" type="button">${t('cfg.addOrder')}</button>`;

            $$('.cfg-s-remove', summaryEl).forEach(b => {
                b.addEventListener('click', () => {
                    configSel[CONFIG_STEPS[parseInt(b.dataset.step)].key] = null;
                    save();
                    render();
                });
            });
            const addBtn = $('#cfgAddOrder');
            if (addBtn) addBtn.addEventListener('click', addConfigToOrder);
        }

        function renderNavHint() {
            const step = CONFIG_STEPS[configStep];
            const id = configSel[step.key];
            const p = id ? COMPONENTS.find(c => c.id === id) : null;
            hintEl.textContent = p
                ? '✓ ' + p.brand + ' ' + p.name + ' — ' + formatPrice(p.price)
                : (configStep === CONFIG_STEPS.length - 1 ? t('cfg.step.last') : t('cfg.step.tip'));
        }

        function addConfigToOrder() {
            const ids = CONFIG_STEPS.map(s => configSel[s.key]);
            if (ids.some(id => !id)) { showToast(t('cfg.step.need')); return; }

            if (IEDNEX_WC) {
                // WooCommerce active: POST each selected component to the WC cart
                // (components must exist as WC products with the matching ID),
                // then redirect to the cart page.
                let remaining = ids.length;
                ids.forEach(id => {
                    fetch(IEDNEX_WC_URL.replace(/\/$/, '') + '/?wc-ajax=add_to_cart', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: 'product_id=' + id + '&quantity=1'
                    }).catch(() => {}).finally(() => {
                        if (--remaining === 0) window.location.href = IEDNEX_WC_URL;
                    });
                });
                return;
            }

            ids.forEach(id => cart.push({ id }));
            if (typeof renderCartItems === 'function') renderCartItems();
            showToast(t('cfg.added'));
        }

        backBtn.addEventListener('click', () => {
            if (configStep > 0) { configStep--; render(); }
        });
        nextBtn.addEventListener('click', () => {
            const step = CONFIG_STEPS[configStep];
            if (!configSel[step.key]) { showToast(t('cfg.step.need')); return; }
            if (configStep < CONFIG_STEPS.length - 1) {
                configStep++;
                render();
            } else {
                addConfigToOrder();
            }
        });

        window.__renderConfigurator = render;

        render();
    }

    /* ===== Shopping Cart ===== */
    let cart = [];
    let renderCartItems = null;

    function initCart() {
        if (IEDNEX_WC) {
            // WooCommerce active: the header badge is updated via WooCommerce
            // cart fragments (see functions.php), so the demo drawer is disabled.
            const cartCount = $('#cartCount');
            if (cartCount) { cartCount.textContent = ''; cartCount.dataset.count = 0; }
            return;
        }
        const cartBtn = $('#cartBtn');
        const cartClose = $('#cartClose');
        const cartOverlay = $('#cartOverlay');
        const cartDrawer = $('#cartDrawer');
        const cartCount = $('#cartCount');
        const cartBody = $('#cartBody');
        const cartEmpty = $('#cartEmpty');
        const cartFooter = $('#cartFooter');
        const cartTotal = $('#cartTotal');

        function openCart() {
            cartOverlay.classList.add('active');
            cartDrawer.classList.add('active');
            document.body.style.overflow = 'hidden';
        }

        function closeCart() {
            cartOverlay.classList.remove('active');
            cartDrawer.classList.remove('active');
            document.body.style.overflow = '';
        }

        renderCartItems = function() {
            cartCount.textContent = cart.length;
            cartCount.dataset.count = cart.length;

            if (cart.length === 0) {
                cartEmpty.style.display = 'block';
                cartFooter.style.display = 'none';
                $$('.cart-item', cartBody).forEach(el => el.remove());
                cartTotal.textContent = formatPrice(0);
            } else {
                cartEmpty.style.display = 'none';
                cartFooter.style.display = 'block';

                $$('.cart-item', cartBody).forEach(el => el.remove());
                let total = 0;

                cart.forEach((item, index) => {
                    const product = PRODUCTS[item.id];
                    if (!product) return;
                    total += product.price;

                    const itemEl = document.createElement('div');
                    itemEl.className = 'cart-item';
                    itemEl.innerHTML = `
                        <div class="cart-item-img">${product.icon}</div>
                        <div class="cart-item-info">
                            <h4>${product.name}</h4>
                            <p>${t('cart.itemDesc')}</p>
                            <div class="cart-item-price">${formatPrice(product.price)}</div>
                        </div>
                        <button class="cart-item-remove" data-index="${index}">✕</button>
                    `;
                    cartBody.appendChild(itemEl);
                });

                cartTotal.textContent = formatPrice(total);

                $$('.cart-item-remove', cartBody).forEach(btn => {
                    btn.addEventListener('click', () => {
                        const idx = parseInt(btn.dataset.index);
                        cart.splice(idx, 1);
                        renderCartItems();
                    });
                });
            }
        };

        $$('.add-to-cart').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                const id = parseInt(btn.dataset.product);
                cart.push({ id });
                renderCartItems();
                const product = PRODUCTS[id];
                showToast(replacePlaceholders(t('toast.added'), { name: product ? product.name : '' }));
                const original = btn.textContent;
                btn.textContent = t('toast.addedOk');
                btn.disabled = true;
                setTimeout(() => {
                    btn.textContent = original;
                    btn.disabled = false;
                }, 1500);
            });
        });

        cartBtn.addEventListener('click', (e) => {
            e.preventDefault();
            openCart();
        });

        cartClose.addEventListener('click', closeCart);
        cartOverlay.addEventListener('click', closeCart);

        // Demo checkout: requires a logged-in account; the order is saved
        // to the account's order history (see handleDemoCheckout).
        cartFooter.addEventListener('click', (e) => {
            if (e.target.closest('.btn-block')) {
                e.preventDefault();
                handleDemoCheckout();
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && cartDrawer.classList.contains('active')) {
                closeCart();
            }
        });
    }

    /* ===== User Account Module =====
       Front-end demo auth: accounts are stored locally in the browser
       (localStorage "iednex-users"), passwords are hashed (SHA-256 via
       crypto.subtle when available, FNV fallback otherwise). Orders from
       the demo checkout are kept per user in "iednex-orders".
       When WooCommerce is active the account button points to the
       WooCommerce "My Account" page instead (see footer.php). */

    function getUsers() { try { return JSON.parse(localStorage.getItem('iednex-users') || '[]'); } catch (e) { return []; } }
    function saveUsers(users) { try { localStorage.setItem('iednex-users', JSON.stringify(users)); } catch (e) {} }
    function getSession() { try { return JSON.parse(localStorage.getItem('iednex-session') || 'null'); } catch (e) { return null; } }
    function setSession(sess) {
        try {
            if (sess) { localStorage.setItem('iednex-session', JSON.stringify(sess)); }
            else { localStorage.removeItem('iednex-session'); }
        } catch (e) {}
    }
    function getOrders() { try { return JSON.parse(localStorage.getItem('iednex-orders') || '[]'); } catch (e) { return []; } }
    function saveOrders(orders) { try { localStorage.setItem('iednex-orders', JSON.stringify(orders)); } catch (e) {} }

    function currentUser() {
        const sess = getSession();
        if (!sess) return null;
        return getUsers().find(u => u.id === sess.uid) || null;
    }

    async function hashPassword(password, salt) {
        const input = salt + '::' + password;
        if (window.crypto && crypto.subtle && window.TextEncoder) {
            try {
                const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(input));
                return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, '0')).join('');
            } catch (e) { /* fall through to fallback */ }
        }
        // Fallback for non-secure contexts (plain http): FNV-style hash.
        let h1 = 0x811c9dc5, h2 = 0xdeadbeef;
        for (let i = 0; i < input.length; i++) {
            const c = input.charCodeAt(i);
            h1 ^= c; h1 = Math.imul(h1, 16777619);
            h2 = Math.imul(h2 ^ c, 2654435761);
        }
        return [h1, h2, h1 ^ h2].map(v => ('0000000' + (v >>> 0).toString(16)).slice(-8)).join('');
    }

    function authError(id, message) {
        const el = $('#' + id);
        if (!el) return;
        if (message) { el.textContent = message; el.hidden = false; }
        else { el.textContent = ''; el.hidden = true; }
    }

    function showAuthView(view) {
        const box = $('.auth-box');
        ['Login', 'Register', 'Profile'].forEach(name => {
            const el = $('#authView' + name);
            if (el) el.hidden = (name.toLowerCase() !== view);
        });
        if (box) box.classList.toggle('auth-box-wide', view === 'register');
    }

    function openAuth(view) {
        const modal = $('#authModal');
        if (!modal) return;
        const user = currentUser();
        let target = view || 'login';
        if (user && (target === 'login' || target === 'register')) target = 'profile';
        if (!user && target === 'profile') target = 'login';
        showAuthView(target);
        if (target === 'profile') renderProfileView();
        authError('loginError', '');
        authError('registerError', '');
        authError('pwError', '');
        modal.classList.add('active');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    }

    function closeAuth() {
        const modal = $('#authModal');
        if (!modal) return;
        modal.classList.remove('active');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
    }

    function updateAccountBtn() {
        const btn = $('#accountBtn');
        const avatar = $('#accountAvatar');
        const svg = btn ? btn.querySelector('svg') : null;
        const user = currentUser();
        if (!btn || !avatar) return;
        if (user) {
            avatar.textContent = (user.name || 'I').trim().charAt(0).toUpperCase();
            avatar.hidden = false;
            if (svg) svg.style.display = 'none';
        } else {
            avatar.hidden = true;
            avatar.textContent = '';
            if (svg) svg.style.display = '';
        }
    }

    function fmtDate(iso) {
        try {
            return new Intl.DateTimeFormat(currentLang === 'de' ? 'de-DE' : 'en-US', {
                year: 'numeric', month: 'long', day: 'numeric'
            }).format(new Date(iso));
        } catch (e) { return iso; }
    }

    function renderProfileView() {
        const user = currentUser();
        if (!user) return;
        $('#profileAvatar').textContent = (user.name || 'I').trim().charAt(0).toUpperCase();
        $('#profileName').textContent = user.name;
        $('#profileEmail').textContent = user.email;
        $('#profileSince').textContent = replacePlaceholders(t('auth.memberSince'), { date: fmtDate(user.createdAt) });
        $('#profileNameInput').value = user.name;
        $('#profileLang').textContent = currentLang.toUpperCase();

        const wrap = $('#profileOrders');
        if (!wrap) return;
        const orders = getOrders().filter(o => o.userId === user.id).sort((a, b) => b.ts - a.ts);
        wrap.innerHTML = '';
        if (orders.length === 0) {
            wrap.innerHTML = '<p class="auth-orders-empty">' + t('auth.orders.empty') + '</p>';
        } else {
            orders.forEach(o => {
                const el = document.createElement('div');
                el.className = 'auth-order';
                el.innerHTML =
                    '<div class="auth-order-head">' +
                        '<strong>' + t('auth.orders.id') + ' #' + o.id + '</strong>' +
                        '<span class="auth-order-status">' + t('auth.orders.status') + '</span>' +
                    '</div>' +
                    '<div class="auth-order-meta">' +
                        '<span>' + fmtDate(o.date) + '</span>' +
                        '<span>' + replacePlaceholders(t('auth.orders.items'), { n: o.items }) + '</span>' +
                        '<strong>' + formatPrice(o.total) + '</strong>' +
                    '</div>';
                wrap.appendChild(el);
            });
        }
    }

    function handleDemoCheckout() {
        const user = currentUser();
        if (!user) {
            openAuth('login');
            showToast(t('auth.checkout.login'));
            return;
        }
        if (cart.length === 0) return;
        let total = 0;
        let count = 0;
        cart.forEach(item => {
            const p = PRODUCTS[item.id];
            if (p) { total += p.price; count++; }
        });
        const orders = getOrders();
        const order = {
            id: String(1000 + orders.length + 1),
            userId: user.id,
            date: new Date().toISOString(),
            ts: Date.now(),
            items: count,
            total: total,
            status: 'processing'
        };
        orders.push(order);
        saveOrders(orders);
        cart.length = 0;
        if (typeof renderCartItems === 'function') renderCartItems();
        renderProfileView();
        openAuth('profile');
        showToast(replacePlaceholders(t('auth.checkout.ok'), { id: order.id }));
    }

    function initAuth() {
        const modal = $('#authModal');
        if (!modal) return;

        // WooCommerce active: the account button opens the WC "My Account" page.
        if (IEDNEX_WC && IEDNEX_WC_ACCOUNT_URL) {
            const btn = $('#accountBtn');
            if (btn) {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    window.location.href = IEDNEX_WC_ACCOUNT_URL;
                });
            }
            return;
        }

        $('#accountBtn').addEventListener('click', (e) => {
            e.preventDefault();
            openAuth();
        });
        $('#authClose').addEventListener('click', closeAuth);
        modal.addEventListener('click', (e) => { if (e.target === modal) closeAuth(); });
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modal.classList.contains('active')) closeAuth();
        });
        $('#toRegister').addEventListener('click', (e) => { e.preventDefault(); showAuthView('register'); });
        $('#toLogin').addEventListener('click', (e) => { e.preventDefault(); showAuthView('login'); });

        // Password visibility toggle
        const passToggle = $('#regPassToggle');
        if (passToggle) {
            passToggle.addEventListener('click', () => {
                const input = $('#regPassword');
                const openEye = $('#passEyeOpen');
                const closedEye = $('#passEyeClosed');
                const isHidden = input.type === 'password';
                input.type = isHidden ? 'text' : 'password';
                if (openEye) openEye.hidden = !isHidden;
                if (closedEye) closedEye.hidden = isHidden;
                passToggle.setAttribute('aria-label', isHidden ? t('auth.password.hide') || 'Passwort verbergen' : t('auth.password.show') || 'Passwort anzeigen');
            });
        }

        // Password strength meter
        const regPassword = $('#regPassword');
        if (regPassword) {
            regPassword.addEventListener('input', () => {
                const val = regPassword.value;
                const bars = $$('.auth-strength-bar', $('#passStrength'));
                const txt = $('#passStrengthText');
                if (!bars.length) return;
                let score = 0;
                if (val.length >= 8) score++;
                if (/[A-Z]/.test(val) && /[a-z]/.test(val)) score++;
                if (/\d/.test(val)) score++;
                if (/[^A-Za-z0-9]/.test(val)) score++;
                const lvl = val.length === 0 ? -1 : score < 2 ? 0 : score < 4 ? 1 : 2;
                bars.forEach((b, i) => {
                    b.className = 'auth-strength-bar' + (i <= lvl && lvl >= 0 ? ' active' : '');
                    b.dataset.level = lvl >= 0 ? lvl : '';
                });
                if (txt) {
                    const labels = ['auth.strength.weak', 'auth.strength.medium', 'auth.strength.strong'];
                    txt.textContent = lvl >= 0 ? t(labels[lvl]) : '';
                }
            });
        }

        const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // ---- Register ----
        $('#registerForm').addEventListener('submit', async (e) => {
            e.preventDefault();
            const firstName = $('#regFirstName').value.trim();
            const lastName = $('#regLastName').value.trim();
            const name = (firstName + ' ' + lastName).trim();
            const email = $('#regEmail').value.trim().toLowerCase();
            const pw = $('#regPassword').value;
            const confirm = $('#regConfirm').value;

            if (firstName.length < 1) return authError('registerError', t('auth.err.firstName'));
            if (lastName.length < 1) return authError('registerError', t('auth.err.lastName'));
            if (!EMAIL_RE.test(email)) return authError('registerError', t('auth.err.email'));
            if (getUsers().some(u => u.email === email)) return authError('registerError', t('auth.err.exists'));
            if (pw.length < 8) return authError('registerError', t('auth.err.len'));
            if (pw !== confirm) return authError('registerError', t('auth.err.match'));
            authError('registerError', '');

            const salt = Math.random().toString(36).slice(2) + Date.now().toString(36);
            const users = getUsers();
            const user = {
                id: 'u' + Date.now().toString(36),
                name: name,
                firstName: firstName,
                lastName: lastName,
                email: email,
                salt: salt,
                passHash: await hashPassword(pw, salt),
                createdAt: new Date().toISOString(),
                lang: currentLang,
                business: $('#regBusiness').checked,
                newsletter: $('#regNewsletter').checked
            };
            users.push(user);
            saveUsers(users);
            setSession({ uid: user.id, ts: Date.now() });
            updateAccountBtn();
            renderProfileView();
            showAuthView('profile');
            $('#registerForm').reset();
            // Reset strength meter
            const bars = $$('.auth-strength-bar', $('#passStrength'));
            bars.forEach(b => { b.className = 'auth-strength-bar'; b.dataset.level = ''; });
            const txt = $('#passStrengthText');
            if (txt) txt.textContent = '';
            showToast(replacePlaceholders(t('auth.welcome'), { name: user.firstName || user.name }));
        });

        // ---- Login ----
        $('#loginForm').addEventListener('submit', async (e) => {
            e.preventDefault();
            const email = $('#loginEmail').value.trim().toLowerCase();
            const pw = $('#loginPassword').value;
            const user = getUsers().find(u => u.email === email);
            if (!user) return authError('loginError', t('auth.err.invalid'));
            const hash = await hashPassword(pw, user.salt);
            if (hash !== user.passHash) return authError('loginError', t('auth.err.invalid'));
            authError('loginError', '');

            setSession({ uid: user.id, ts: Date.now() });
            // Restore the user's saved language preference.
            if (user.lang && I18N[user.lang] && user.lang !== currentLang) setLanguage(user.lang);
            updateAccountBtn();
            renderProfileView();
            showAuthView('profile');
            $('#loginForm').reset();
            showToast(replacePlaceholders(t('auth.welcome'), { name: user.name }));
        });

        // ---- Profile: edit name ----
        $('#profileForm').addEventListener('submit', (e) => {
            e.preventDefault();
            const user = currentUser();
            if (!user) return;
            const name = $('#profileNameInput').value.trim();
            if (name.length < 2) return;
            const users = getUsers();
            const u = users.find(x => x.id === user.id);
            if (!u) return;
            u.name = name;
            saveUsers(users);
            renderProfileView();
            updateAccountBtn();
            showToast(t('auth.saved'));
        });

        // ---- Profile: change password ----
        $('#pwForm').addEventListener('submit', async (e) => {
            e.preventDefault();
            const user = currentUser();
            if (!user) return;
            const current = $('#pwCurrent').value;
            const next = $('#pwNew').value;
            const confirm = $('#pwConfirm').value;
            const hash = await hashPassword(current, user.salt);
            if (hash !== user.passHash) return authError('pwError', t('auth.err.current'));
            if (next.length < 8) return authError('pwError', t('auth.err.len'));
            if (next !== confirm) return authError('pwError', t('auth.err.match'));
            authError('pwError', '');

            const users = getUsers();
            const u = users.find(x => x.id === user.id);
            if (!u) return;
            u.passHash = await hashPassword(next, u.salt);
            saveUsers(users);
            $('#pwForm').reset();
            showToast(t('auth.pw.ok'));
        });

        // ---- Logout ----
        $('#logoutBtn').addEventListener('click', () => {
            setSession(null);
            updateAccountBtn();
            closeAuth();
            showToast(t('auth.bye'));
        });

        // ---- Delete account ----
        $('#deleteAccountBtn').addEventListener('click', () => {
            const user = currentUser();
            if (!user) return;
            if (!window.confirm(t('auth.deleteConfirm'))) return;
            saveUsers(getUsers().filter(u => u.id !== user.id));
            saveOrders(getOrders().filter(o => o.userId !== user.id));
            setSession(null);
            updateAccountBtn();
            closeAuth();
            showToast(t('auth.deleted'));
        });

        // Re-render the profile view (order list / formatted dates) on
        // language change while the profile is visible.
        window.__renderProfile = function() {
            const view = $('#authViewProfile');
            if (view && !view.hidden) renderProfileView();
        };

        updateAccountBtn();
    }

    /* ===== Toast Notification ===== */
    let toastTimer;
    function showToast(message) {
        const toast = $('#toast');
        toast.textContent = '';
        toast.appendChild(document.createTextNode(message));
        toast.classList.add('active');

        clearTimeout(toastTimer);
        toastTimer = setTimeout(() => {
            toast.classList.remove('active');
        }, 3000);
    }

    /* ===== Newsletter Form ===== */
    function initNewsletter() {
        const form = $('#newsletterForm');
        if (!form) return;

        form.addEventListener('submit', (e) => {
            e.preventDefault();
            const email = form.querySelector('input').value;
            if (email) {
                showToast(replacePlaceholders(t('news.success'), { email }));
                form.reset();
            }
        });
    }

    /* ===== Category Card Hover ===== */
    function initCategoryCards() {
        $$('.category-card').forEach(card => {
            card.addEventListener('mouseenter', () => {
                card.style.borderColor = 'var(--accent-primary)';
            });
            card.addEventListener('mouseleave', () => {
                card.style.borderColor = '';
            });
        });
    }

    /* ===== Smooth Scroll for Anchor Links ===== */
    function initSmoothScroll() {
        $$('a[href^="#"]').forEach(link => {
            link.addEventListener('click', (e) => {
                const href = link.getAttribute('href');
                if (href === '#' || href.length <= 1) return;

                const target = document.querySelector(href);
                if (target) {
                    e.preventDefault();
                    const offset = 80;
                    const top = target.getBoundingClientRect().top + window.scrollY - offset;
                    window.scrollTo({ top, behavior: 'smooth' });
                }
            });
        });
    }

    /* ===== Reveal on Scroll ===== */
    function initScrollReveal() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('revealed');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.1 });

        $$('.category-card, .product-card, .adv-card, .highlight-card, .series-card').forEach(el => {
            el.style.opacity = '0';
            el.style.transform = 'translateY(20px)';
            el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
            observer.observe(el);
        });

        const style = document.createElement('style');
        style.textContent = '.revealed { opacity: 1 !important; transform: translateY(0) !important; }';
        document.head.appendChild(style);
    }

    /* ===== Init All ===== */
    document.addEventListener('DOMContentLoaded', () => {
        initLangSwitcher();
        initTopBarSlider();
        initHeaderScroll();
        initMobileMenu();
        initSearch();
        initHeroCarousel();
        initHighlightsCarousel();
        initConfigurator();
        initTopsellerTabs();
        initDeals();
        initComponents();
        initFpsChecker();
        initCart();
        initAuth();
        initNewsletter();
        initCategoryCards();
        initSmoothScroll();
        initScrollReveal();

        // Apply initial language (from localStorage or default 'de')
        applyTranslations();

        console.log('%c⚡ IEDNEX', 'font-size: 24px; font-weight: bold; background: linear-gradient(135deg, #76b900, #a4e000); -webkit-background-clip: text; -webkit-text-fill-color: transparent; padding: 8px;');
        console.log('%cPremium Gaming PCs & Workstations - DE / EN', 'color: #a0a0b0; font-size: 14px;');
    });

})();
